import { LOCALES } from '../../utils/i18n/constants'

export default {
  [LOCALES.FRENCH]: {
    't_aas': 'Tous les secteurs',
    't_parent_fund': '(FR Parent fund)',
    't_account_locked': 'Compte bloqué',
    't_action': 'Action',
    't_horizontal_artificial_areas': 'FR Horizontal artificial areas',
    't_vertical_artificial_areas': 'FR Vertical artificial areas',
    't_generic_number_message': 'FR {field} must be a number',
    't_generic_positivenumber_message': 'FR {field} must be a positive number',
    't_horizontal_artificial_less_than_total_message': 'FR Horizontal artificial cannot be greater than the total horizontal area',
    't_vertical_artificial_less_than_total_message': 'FR Vertical artificial cannot be greater than the total vertical area',
    't_planning_permission_date_before_purchase': 'FR Must be before the year the asset was built (see Asset Details)',
    't_action_error_message': 'Veuillez corriger les problèmes surlignés en rouge',
    't_action_excel': 'SIERA Plan d\'action.xlsx',
    't_action_pdf': 'SIERA Plan d\'action.pdf',
    't_action_plan': 'Plan d\'action',
    't_action_completion_dates': 'Les dates de complétion des actions approchent',
    't_resource_consumption_extended': 'FR If development work occurred, indicate the total tonnes of raw materials used, the amount which was sustainably sourced, and the project period. Otherwise, leave this blank.',
    't_actions': 'Actions',
    't_actions_under_review': 'Actions en cours d\'examen',
    't_actual': 'Réel',
    't_grey': 'Non couvert',
    't_reports_resource_consumption_not_found_msg': 'FR {areas}cannot be empty if current status is Major Renovation or New Construction.',
    't_sustainableweight_not_found_msg': 'FR {areas} cannot be empty.',
    't_totalweight_not_found_msg': 'FR {areas} cannot be empty.',
    't_startdate_not_found_msg': 'FR {areas} cannot be empty.',
    't_enddate_not_found_msg': 'FR {areas} cannot be empty.',
    't_reports_sustainableweight_not_found': 'FR Sustainable Weight',
    't_reports_totalweight_not_found': 'FR Total Weight',
    't_reports_startdate_not_found': 'FR Start Date',
    't_reports_enddate_not_found': 'FR End Date',
    't_add_action': 'Ajouter une action',
    't_no_action_data': 'Il n\'y a aucune action à afficher',
    't_add_an_action': 'Ajouter une action',
    't_add_action_title': 'Ajouter un titre à l\'action',
    't_add_date': 'Ajouter une date',
    't_add_note': 'Ajouter une note',
    't_add_note_description': 'Ajouter une note pour expliquer cet écart dans la consommation d\'énergie par rapport aux objectifs convenus.',
    't_agreed': 'Accepté',
    't_agreed_actions': 'Actions convenues',
    't_asset_agree_actions': 'FR Agreed actions',
    't_all': 'Tout',
    't_all_actions': 'Toutes les actions',
    't_alu': 'Tous les services',
    't_api_email_error': 'E-mail de l\'utilisateur introuvable',
    't_applicable': 'Applicable',
    't_applicable_actions': 'Actions applicables',
    't_approved': 'Approuvé',
    't_apr': 'Avr.',
    't_april': 'Avril',
    't_assets_missing_performance_targets': 'Actifs sans objectifs de performance',
    't_asset_summary': 'Résumé de l\'Actif',
    't_assets': 'Actifs',
    't_asset_s': 'Actifs',
    't_aug': 'Août',
    't_august': 'Août',
    't_back_sign_in': 'Retour à Se connecter',
    't_biodiversity': 'Biodiversité',
    't_break': 'interruption',
    't_email_hint': 'FR Recipients (separate multiple email addresses with commas)',
    't_btn_enter': 'Saisir les données',
    't_btn_request': 'Demande de données',
    't_building_manager': 'Gestionnaire du bâtiment',
    't_building_performance': 'Performances du bâtiment',
    't_cancel': 'Annuler',
    't_capital_non_recover': 'Capital - Non récupérable',
    't_capital_recover': 'Capital - Récupérable',
    't_carbon': 'Charbon',
    't_cbx_label_all': 'Sélectionner tout',
    't_certifications': 'Certifications',
    't_certificates': 'FR Certificates',
    't_change': 'Modifier',
    't_change_password': 'Modifier le mot de passe',
    't_check_all_completed': 'Cocher toutes tâches terminées',
    'close.without.save': 'Fermer sans sauvegarder',
    't_commercial_event': 'Événement commercial',
    't_commercial_events': 'Événements commerciaux',
    't_commonareas': 'Parties communes',
    't_community_engagement': 'Engagement communautaire',
    't_complete_by': 'COMPLÉTER AVANT',
    't_complete': 'Terminer',
    't_completed': 'Terminé',
    't_completed_actions': 'Actions effectuées',
    't_completion': 'Achèvement',
    't_completion_date': 'Date de livraison',
    't_confirm_new_password': 'Confirmer le nouveau mot de passe',
    't_contact_evora': 'Contactez EVORA',
    't_contact_problem_msg_1': 'Problème d\'accès?',
    't_contact_problem_msg_2': 'Vous avez des problèmes?',
    't_contact_us': 'Nous contacter',
    't_content': 'Contenu',
    't_cookies': 'Cookies',
    't_cookies_page': '<h1>Use of Cookies</h1><p>This site uses cookies – small text files that are placed on your machine to help the site provide a better user experience.</p><p>In general, cookies are used to retain user preferences, store information for things like shopping baskets, and provide anonymised tracking data to third party applications like Google Analytics. As a rule, cookies will make your browsing experience better. However, you may prefer to disable cookies on this site and on others. The most effective way to do this is to disable cookies in your browser. We suggest consulting the \'Help\' section of your browser or taking a look at the <aboutcookies>About Cookies</aboutcookies> website, which offers guidance for all modern browsers.</p><p>We use cookies to ensure that we give you the best experience on our website. There are 3 types of cookie that we use on this website:</p><h3>1. Strictly Necessary Cookies</h3><p>These cookies are used to enable core site functionality and make the site easier for you to use. They do not contain any personal information and are automatically deleted when you close your browser.</p><h3>2. Google Analytics Cookies</h3><p>These cookies provide us with statistics on how our website is used, so that we can measure and improve the performance of the site, using a service provided by Google.</p><p>Most browsers allow you to turn off the cookie function. If you want to know how to do this please look at the help menu on your browser.</p><h3>Access rights</h3><p>You have a right to access the personal data that is held about you. To obtain a copy of the personal information EVORA holds about you, or to have it deleted from our records altogether (unless it\'s information that we have the right to retain), please email <emailevora>info@evoraglobal.com</emailevora> or call us on +44 (0)20 3326 7333.</p>',
    't_cost': 'Coût',
    't_cost_type': 'Type de coût',
    't_create_password': 'Créer un nouveau mot de passe',
    't_current_password': 'Mot de passe actuel',
    't_data': 'FR Data',
    't_no_records_found': 'FR No records found',
    't_dashboard': 'Tableau de bord',
    't_dashboard_pdf': 'SIERA Tableau de bord.pdf',
    't_data_quality': 'Qualité des données',
    't_data_quality_two_lines': 'Qualité {br} des données',
    't_date': 'Date',
    't_dec': 'Déc.',
    't_december': 'Décembre',
    't_detail': 'Détail',
    't_district_cooling': 'Climatisation urbaine',
    't_districtcooling': 'Climatisation urbaine',
    't_district_heating': 'Chauffage urbain',
    't_districtheating': 'Chauffage urbain',
    't_dq_data_entered': 'Données saisies',
    't_dq_data_provided_on': 'Fourni le',
    't_dq_data_requested': 'Données demandées',
    't_dq_data_requested_on': 'Demande effectuée le',
    't_due_date': 'Date d\'échéance',
    't_biodiversity_extended': 'FR Indicate the total surface areas of the building, and the portion of these surface areas which is non-vegetated.',
    't_occupancy_extended': 'FR Track the proportion of lettable floor area occupied over time.',
    't_planning_permission_extended': 'FR Indicate the date the asset received planning permission. This is used to determine the energy efficiency standards the building must meet.',
    't_fossil_fuel_exposure_extended_edit_data': 'FR Track whether the asset is involved in the extraction, transport, storage or manufacture of fossil fuels. This status should be confirmed quarterly.',
    't_ped_extended': 'FR Indicate the Primary Energy Demand (PED) of the asset, and the Nearly Zero-Energy Building (NZEB) Threshold against which this is compared, if applicable.',
    't_gav_extended': 'FR Track the gross value of the asset.',
    't_waste_contracts_extended': 'FR Track whether the asset is equipped with facilities for waste sorting and covered by a waste recovery or recycling contract.',
    't_edit': 'Modifier',
    't_electricity': 'Électricité',
    't_email': 'Votre e-mail',
    't_report_data_checklist': 'FR Report data checklist',
    't_planning_permission': 'FR Planning Permission',
    't_periodic_reporting_data': 'FR Periodic reporting data',
    't_waste_contracts': 'FR Waste Contracts',
    't_report_data_checklist_info': 'FR Select a reporting framework to highlight data readiness issues.',
    't_email_reset': 'Veuillez vérifier votre e-mail pour connaitre les détails pour vous connecter.',
    't_email_notifications': 'Notifications par e-mail',
    't_energy': 'Énergie',
    't_energyintensity': 'FR Energy Intensity',
    't_energy_rating': 'Classe énergétique',
    't_EPC_rating': 'FR EPC rating',
    't_Asset_EPC_rating': 'FR EPC ratings',
    't_english': 'Anglais',
    't_enter_data': 'Saisir les données',
    't_enter_current_password': 'Veuillez saisir votre mot de passe actuel',
    't_error': 'Désolé, vous ne pouvez pas vous connecter',
    't_error_account_locked': 'Le compte est bloqué en raison d\'une trop grand nombre de tentatives infructueuses.',
    't_error_account_revoked': 'Un administrateur a révoqué votre accès à ce compte.',
    't_error_back_to_homepage': 'Retour à la page d\'accueil',
    't_error_try_msg': 'Réessayez dans quelques heures.',
    't_error_user_password': 'E-mail/mot de passe incorrect, veuillez réessayer',
    't_error_user_no_access': 'E-mail/mot de passe incorrect, veuillez réessayer',
    't_esg_action_plan': 'Plan d\'action',
    't_esg_dashboard': 'Tableau de bord',
    't_esg_data_quality': 'Qualité des données',
    't_esg_passport': 'Passeport',
    't_esg_performance': 'Performance',
    't_portfolio_pdf': 'FR SIERA Portfolio.pdf',
    't_date_range': 'FR Date range',
    't_add_cost_estimate': 'FR Add cost estimate',
    't_add_manager': 'FR Add manager',
    't_est': 'EST.',
    't_estimated_overspend': 'dépassements estimés',
    't_event': 'Évènement',
    't_events': 'Événements',
    't_excel': 'Excel',
    't_expand_full_list': 'Dérouler toute la liste',
    't_expiry': 'expiration',
    't_export': 'Exporter',
    't_exterior': 'Extérieur',
    't_feb': 'Févr.',
    't_february': 'Février',
    't_find_asset': 'Trouver un actif',
    't_floor_area': 'Superficie',
    't_forgot_password': 'Mot de passe oublié',
    't_french': 'Français',
    't_friday': 'Vendredi',
    't_fund': 'Fond',
    't_fund_reports': 'FR Reports',
    't_fund_report_content': 'FR Report Content',
    't_gas': 'Gaz',
    't_gasFuelsAndThermals': 'Carburants Et Thermiques',
    't_gas_fuel_thermal': 'Gaz, combustibles et thermiques',
    't_gasfuelsandthermals': 'Gaz, combustibles et thermiques',
    't_german': 'Allemand',
    't_go_back': 'Retour',
    't_governance_recommendations': 'Recommandations en matière de gouvernance',
    't_graph_landlord': 'Propriétaire',
    't_tenant': 'Locataire',
    't_graph_ytd': 'Depuis le début de l\'année',
    't_gresb_measure': 'Actions connexes du GRESB',
    't_health_and_wellbeing': 'Santé et bien-être',
    't_heatmap_header': 'Mètres individuels',
    't_heatmap_no_meterdata_msg': 'Aucune donnée de compteur trouvée pour le service et la zone sélectionnés.',
    't_impact': 'Impact',
    't_in_progress': 'En cours',
    't_incorrect_current_password': 'Le mot de passe actuel est incorrect.',
    't_invalid_token': 'Jeton invalide.',
    't_italian': 'Italien',
    't_jan': 'Janv.',
    't_january': 'Janvier',
    't_jpg': 'graphiques JPG',
    't_jul': 'Juill.',
    't_july': 'Juillet',
    't_jun': 'Juin',
    't_june': 'Juin',
    't_kg': 'kg',
    't_kWh': 'kWh',
    't_land_fill': 'Décharge',
    't_landfill': 'Décharge',
    't_landfill_remaining': 'Décharge restante',
    't_landlord': 'Propriétaire',
    't_landlord_complete': 'Propriétaire terminé',
    't_landlord_missing': 'Propriétaire manquant',
    't_language': 'Langue',
    't_last_quarter': 'Dernier trimestre',
    't_last_refurb': 'Dernière rénovation.',
    't_last_refurbished': 'Dernière rénovation',
    't_latest': 'dernier',
    't_location': 'Localisation',
    't_logout': 'Déconnexion',
    't_m': 'M',
    't_manager': 'Responsable',
    't_mar': 'Mars',
    't_march': 'Mars',
    't_may': 'Mai',
    't_missing': 'INCOMPLÈTE',
    't_missing_tc': 'Manquant',
    't_missing_lc': 'manquant',
    't_missing_performance_data': 'Données de performances manquantes',
    't_missing_data': 'Donnée manquante',
    't_missing_data_meter': 'Mètre',
    't_missing_data_reading': 'Lecture',
    't_missing_data_type': 'Type',
    't_monday': 'Lundi',
    't_msg_empty_msg': 'Il n\'y a aucune donnée manquante pour cette période',
    't_msg_no_data': 'Aucune donnée',
    't_msg_qtr_empty': 'Aucun écart de données enregistré pour la période sélectionnée',
    't_nc': 'NC',
    't_not_covered_uc': 'FR NOT COVERED',
    't_new_password': 'Nouveau mot de passe',
    't_no': 'Non',
    't_no_action_plan': 'Désolé, aucune donnée trouvée.',
    't_no_completed_action': 'Désolé, aucune donnée n\'a été trouvée pour les actions terminées.',
    't_no_data_msg_1': 'Désolé, nous n\'avons trouvé aucun résultat avec {0} - Essayez un autre terme de recherche.',
    't_no_data_msg_2': 'Désolé, nous n\'avons trouvé aucun résultat.',
    't_no_events_found': 'Désolé, nous n\'avons trouvé aucun événement.',
    't_non_recycled': 'non recyclé',
    't_none': 'Aucun',
    't_non_rec': 'NON-REC',
    't_non_applicable': 'Non applicable',
    't_notes': 'Remarques',
    't_notif_template_action': '{0} action est à 1 mois de sa date d\'échéance. {1}',
    't_notif_template_action_link_1': 'Ajouter une mise à jour',
    't_notif_template_data_quality': '{0} données manquantes pour compteur: {1}. {2} or {3} d\'un collègue.',
    't_notif_template_data_quality_link_1': 'Demander les données',
    't_notif_template_performance': 'La performance de {0} pour {1} est {2}% {3} objectif. {4} pour expliquer la variance.',
    't_notif_template_performance_link_1': 'Ajouter une note',
    't_notifications': 'Notifications',
    't_nov': 'Nov.',
    't_november': 'Novembre',
    't_occupancy': 'Taux d\'occupation',
    't_oct': 'Oct.',
    't_october': 'Octobre',
    't_oil': 'Pétrole',
    't_one_year': '1 An',
    't_other': 'Autre',
    't_other_notifications': 'Nous vous informerons également lorsque: ',
    't_outdoorexteriorareaparking': 'Aire de stationnement extérieure',
    't_over': 'dépassé',
    't_est_overspend': 'coût supplémentaire estimé',
    't_passport': 'Passeport',
    't_passport_pdf': 'SIERA Passeport.pdf',
    't_password': 'Votre mot de passe',
    't_password_criteria': 'Le mot de passe ne répond pas aux exigences',
    't_password_mismatch': 'Les mots de passe ne correspondent pas, veuillez vérifier',
    't_password_rules': 'Doit comporter au moins  10 caractères et inclure une lettre majuscule, un caractère minuscule, un chiffre et un caractère spécial.',
    't_past_12_months': '12 derniers mois',
    't_pdf': 'PDF pleine page',
    't_pdf_exported': 'PDF exporté',
    't_pdf_page': 'Page',
    't_pdf_pagination_copyright': '© La conception et la mise en page de ce rapport sont la propriété d\'EVORA Global Limited. Les données contenues dans ce rapport sont basées uniquement sur les données fournies par le client et appartiennent au client. EVORA Global Limited n\'est pas responsable de la qualité ou de l\'exactitude de ces données.',
    't_perf_pdf': 'SIERA Performance.pdf',
    't_performance': 'Performance',
    't_performance_commerial_event_template': '{0} bail du locataire {1}',
    't_performance_completed_action_template': '{0} - complété',
    't_performance_data_missing_event_template': '{0} données manquantes pour {1} compteur',
    't_performance_event_template': '{0} consommation pour {1} est de {2}% {3} objectif',
    't_performance_event_waste_template': '{0} performances pour {1} est de {2}% {3} objectif',
    't_performance_variance': 'Performance',
    't_data_quality_issue': 'Qualité des données',
    't_pop_up_data_missing': 'Données manquantes',
    't_portfolio_name': 'Portefeuille',
    't_posted': 'Publié',
    't_privacy': 'Politique de confidentialité',
    't_privacy_page': '<h1>Privacy Policy</h1><p><b>EVORA is committed to protecting your privacy.</b></p><p>At EVORA Global we respect your privacy and commit to protecting your personal data. This “privacy notice” explains what we do with your personal data, why we want to use it, how we protect it, and what rights you have to control our use of it.</p><p>It applies not just to use of our website and data platforms, but also personal data that we process through other interactions with individuals in the course of running our organisation and delivering services, such as individuals working for our customers, partners and suppliers. Our websites and services are not intended for children and we do not knowingly collect data relating to children.</p><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora>.</p><h3>Some information about us as a data controller</h3><p>This privacy notice is for the EVORA Global Ltd (collectively referred to as “EVORA Global”, “we”, “us” or “our” in this privacy notice). We collect, use and are responsible for certain personal data about you. When we do so we are regulated under data protection laws and we are responsible as “data controller” of that personal information for the purposes of the law.</p><p>Our contact address is: 3rd Floor, Birrane House, 2-4 Southwark Street, London, SE1 1TQ. Our company number is 07450294.</p><h3>What personal data do we process and why?</h3><p>Personal data, or personal information, means any information about an individual from which that person can be identified. It does not include data where the identity has been removed (anonymous data).</p><p>We use personal data from different categories of individual for different purposes and these each have a different \'lawful basis\'. This section describes the lawful basis and purposes in detail and, although it\'s technical, we\'re required by law to explain this to you.</p><p><strong>If you visit our website:</strong>we use Google Analytics on our website to track visitor numbers and user activity on our site. We record your computer\'s IP address, so we can tell how each user and repeat visitor is using our site (your IP address is also a piece of your personal data). We do this on the basis that it is necessary for our legitimate interests in tracking website users so that we can improve our service and keep our websites relevant and useful. The IP address information will be held for 26 months after last user activity.</p><p><strong>If you are a member of our mailing list:</strong>we will use your email address for the purpose of sending you blog posts, our monthly newsletters, and invitations to our events and workshops. We have this data if you signed up on our website or if you provided us with your contact details by email or when meeting our staff. We process this data on the basis that it is necessary for our legitimate interests in promoting and marketing our business. If you no longer wish to hear from us just click the “unsubscribe” links at the bottom of each email.</p><p><strong>If you are a SIERA account holder:</strong> we will hold your name, username and email address on the basis that it is necessary for our legitimate interests in operating a building sustainability data platform for clients. You or your employer will have provided these details through the account creation process. We need these details for the purpose of enabling secure access to the data platform by staff and workers in the supply chain of our clients. We may use this information for internal analysis purposes to understand client platform engagement. We may also report information around your usage of the SIERA tool back to our client, where you work for such client or in such client\'s supply chain (see below). It is in our legitimate interests to provide feedback to our clients for purposes of running and growing our business, and assists us in responding to the needs of our clients. It is also of benefit to our clients to be aware of this usage information. If you no longer require your account, you can email us (see “How to contact us” below). We will hold your information until you or we delete your account.</p><p><strong>If you work for one of our clients or in our clients\' supply chain, or if you are an industry contact or working in a field relevant to our mission:</strong>we may hold your name, company, job title and contact details. We will have been provided with this data either by you or your employer or in some cases we may have sourced it from publicly available sources, such as LinkedIn, internet searches, or third parties. If you have been in contact with us by email or phone we may also have copies of email exchanges or conversation notes. We need this data in order to interact with you (or your employer) for the following purposes:</p><p>1. To run and develop our business; 2. To communicate with interested people regarding events, news and updates.</p><p>We do this on the basis that it is necessary for our legitimate interests in running and growing our business. We will hold your details for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><p><strong>If you submit an application to join us, whether as an employee or contractor:</strong>we will hold any personal information you provide to us (via our website or other methods), or that is sent to us by a thirdparty recruitment agency or website. This is likely to be your name, contact details and personal information contained in your CV. We do this on the basis that it is necessary for our legitimate interests in recruiting talented people. We will use this information for the purpose of communicating with you and evaluating your application. We will hold this information for as long as we need to interact with you for these purposes or until you ask us to delete it.</p><p><strong>If you are a supplier or work for a supplier:</strong>we may hold your name and contact details because we have a legitimate interest in doing business with your company. Our purpose for processing your personal data is to interact with you or your employer to procure and pay for goods and services. We will hold this information for as long as we need to interact with you for these purposes. In all cases if you would like us to update or delete your information, please send us an email (see “How to contact us” below).</p><h3>Retention of personal data</h3><p>We will only retain your personal data for as long as necessary to fulfil the purposes we collected it for, including for the purposes of satisfying any legal, accounting, or reporting requirements, taking into account applicable data protection laws, retention periods under applicable laws, limitation periods and our business needs.</p><h3>Sharing your personal data</h3><p><strong>Data processors</strong></p><p>We use a number of different service providers (acting as \'data processors\') who provide IT and system administration services to enable us to operate our business and the services we provide to our users and partners. Your personal data is transferred to (and stored by) these data processors, who generally fall under the following categories:</p><ul><li>Website analytics service providers</li><li>Website and data hosting service providers</li><li>Document storage service providers</li><li>Email, contacts, instant messaging and calendar service providers</li><li>Project management software providers</li><li>CRM service providers</li><li>Accounting software service providers</li></ul><p>For security reasons we do not name all our service providers in this privacy notice. The types of personal data we hold about you (and that may be transferred to our data processors) are set out above. Please contact us if you want further information on specific data processors or the types of personal data they process for us</p><p><strong>If you attend one of our events</strong></p><p>The name and company of attendees at our events may be shared with other participants and may be shared on our website.</p><p>If the event is co-organised with another organisation, then the name and company of attendees may also be shared with that partner organisation to enable access and name badges etc.</p><p><strong>Other circumstances in which we may need to share personal data with third parties</strong></p><p>We may also share your personal data with the following third parties in certain circumstances:</p><ul><li>We will share personal information with law enforcement or other authorities (such as tax authorities) if required by applicable law.</li><li>We may share personal information with third parties as part of a merger or transfer, acquisition or sale, or in the event of a bankruptcy. In such case, we will require the relevant third parties to provide comparable levels of protection as we provide with respect to the information we share.</li><li>We may share personal information with professional advisors such as lawyers, accountants or auditors in order for them to provide us with legal, accounting or auditing services.</li><li>We may share personal information with consultants working for us where this is necessary for them to provide their services to us or our clients.</li><li>We may share personal information with our partner company EVORA EDGE Limited – where this is necessary for them to provide services for the benefit of our clients.</li></ul><p>We will not sell or rent your information to third parties and we will never share your information with third parties for marketing purposes.</p><h3>International transfers of personal data, and the measures in place to safeguard it</h3><p>We do not directly transfer any of your personal data outside the UK or the European Economic Area (EEA). However, some of our data processors may do so and this section explains the impact of these international transfers and how your information is protected.</p><p>Many of our data processors operate “cloud-based systems”, which means the information is held in information data centres in different locations. In some cases, they hold copies of your personal information outside the UK or EEA.</p><p>In each case our processors and/or we employ one or more of the transfer safeguard mechanisms designated by data protection legislation, which are designed to help safeguard your privacy rights and give you remedies in the unlikely event of abuse. These include:</p><ul><li>Certain processors may only transfer your personal data to countries that have been deemed to provide an adequate level of protection for personal data by the UK government or the European Commission. For further details, on EU adequacy decisions see: <europeancommission>European Commission: Adequacy of the protection of personal data in non-EU countries.</europeancommission></li><li>Where we use certain service providers, we may use standard contractual clauses approved by the European Commission or UK ICO, which give personal data the same protection it has in Europe. For further details, see: <europeancommissionstandard>European Commission: Standard Contractual Clauses.</europeancommissionstandard></li></ul><p>Please contact us (see below) if you want further information on the specific mechanisms used by our data processors when transferring your personal data out of the UK or EEA.</p><h3>Your personal data rights</h3><p>The personal data we hold about you is your data, and you have certain rights over the data under applicable data protection laws. This section summarises the rights you have where your personal data is protected under UK data protection legislation.</p><ul><li>You have the right to request a copy of all personal data we hold relating to you. You also have the right to require us to correct any mistakes in the personal data we hold relating to you.</li><li>Where we are processing your data based on your consent you can withdraw that consent and we must immediately stop processing your data.</li><li>Where we process your data based on a “legitimate interest” (underlined in the section on “purpose and lawful basis”, above) you still have the right to object to our processing of that data if you feel it impacts on your fundamental rights and freedoms.</li><li>You also have the right to object where we are processing your personal data for direct marketing purposes. The easiest way to do this is to use the unsubscribe links at the bottom of all marketing emails</li><li>In certain situations, you have the right to require us to erase personal data where there is no good reason for us continuing to process it, or to request restriction of processing of your personaldata.</li><li>Finally, you have the right to request the transfer of your personal data to you or a third party in a structured, commonly used, machine-readable format in certain circumstances.</li></ul><p>For further information on each of these rights, including the circumstances in which they apply, see the <guidanceuk>Guidance from the UK Information Commissioner\'s Office (ICO) on individuals rights under the General Data Protection Regulation.</guidanceuk></p><p>If you would like to exercise any of these rights, the easiest way is by dropping us an email (see “How to contact us” below).</p><h3>Automated processing of your personal data</h3><p>You have a right to object to any decisions being taken through the processing of your personal data by automated means if they produce legal effects concerning you or similarly significant effects on you. We can confirm that we do not undertake any automated decision-making, or profiling, based on the processing of personal data.</p><h3>Keeping your personal information secure</h3><p>We have appropriate security measures in place to prevent personal information from being accidentally lost, or used or accessed in an unauthorised way. In addition, we limit access to your personal data to those employees, contractors and other third parties who have a business need to know. They will only process your personal data on our instructions and they are subject to a duty of confidentiality.</p><p>We also have procedures in place to deal with any suspected data security breach. We will notify you and any applicable regulator of a suspected data security breach where we are legally required to do so.</p><h3>Your rights to lodge a complaint with the Regulator</h3><p>At all times, you have the right to report a concern or lodge a complaint with the Information Commissioner\'s Office. Please refer to the ICO at<icoorg> https://ico.org.uk/concerns/</icoorg> or by calling them on 0303 123 1113. Of course, we hope that we can resolve your issue quickly and fairly ourselves.</p><h3>Changes to this privacy notice</h3><p>This privacy notice was last updated on 16th February 2021. We may change this privacy notice from time to time by amending this page.</p><h3>How to contact us</h3><p>If you have any questions, concerns or just want some more information about our privacy management, drop us a line at <emailevora>dataprivacy@evoraglobal.com</emailevora></p>',
    't_quarterly_email_notification': 'Recevez des e-mails trimestriels mettant en évidence : ',
    't_recycled': 'Recyclé',
    't_reduction': 'Réduction',
    't_req_from': 'De',
    't_req_hi': 'Bonjour',
    't_red': 'Données manquantes',
    't_req_meter': 'Mètre',
    't_req_missing_data_period': 'Période(s) des données manquantes',
    't_req_recipient': 'Destinataires',
    't_req_send': 'Envoyer',
    't_req_subject': 'Objet',
    't_req_thanks': 'Merci',
    't_req_utility': 'Service',
    't_request_data': 'Demande de données',
    't_req_supplier': 'FR Supplier (if known)',
    't_revenue_service': 'Revenus - Frais de service',
    't_saturday': 'Samedi',
    't_save': 'Enregistrer',
    't_saving': 'économies estimées',
    't_scope': 'Champ d\'application',
    't_select': 'Sélectionner',
    't_send_reminder': 'Envoyez un rappel',
    't_sep': 'Sept.',
    't_september': 'Septembre',
    't_set_dates': 'Définir les dates',
    't_set_reminder_date': 'Paramétrer un rappel de date',
    't_settings': 'Paramètres',
    't_sharedservices': 'Services partagés',
    't_show_more': 'Afficher plus',
    't_sign_in': 'Se connecter',
    't_six_months': '6 Mois',
    't_social_value': 'Valeur sociale',
    't_sort_by': 'Trier par',
    't_spanish': 'Espagnol',
    't_status': 'Statut',
    't_submit': 'Envoyer',
    't_sunday': 'Dimanche',
    't_swedish': 'Suédois',
    't_targets': 'FR Targets',
    't_targets_and_pathways': 'FR Targets & Pathways',
    't_task': 'Tâche',
    't_template_qtr_label': '{0} {1} - {2} {3}',
    't_tenant_complete': 'Locataire terminé',
    't_tenant_missing': 'Locataire manquant',
    't_tenant_engagement': 'Participation des locataires',
    't_tenant_services': 'Services aux locataires',
    't_tenantspace': 'Espace Locatif',
    't_terms': 'Conditions',
    't_this_quarter': 'Ce trimestre',
    't_three_months': '3 Mois',
    't_thursday': 'Jeudi',
    't_title_cannot_request_data': 'Impossible de demander des données',
    't_title_cannot_post_data': 'FR Add user failed',
    't_title_cannot_put_data': 'FR Update user failed',
    't_title_cannot_put_data_group': 'FR Update group failed',
    't_title_cannot_post_data_group': 'FR Add group failed',
    't_title_cannot_add_asset': 'FR Add asset failed',
    't_today': 'Aujourd\'hui',
    't_ton': 't',
    't_tonnes': 'tonnes',
    't_total': 'Total',
    't_total_recycling': 'Recyclage total',
    't_try_again': 'Réessayer',
    't_tuesday': 'Mardi',
    't_type': 'Type',
    't_under': 'au-dessous de',
    't_under_review': 'En cours d\'examen',
    't_under_target': 'en dessous de l\'objectif pour la période',
    't_util_cooling': 'Climatisation urbaine',
    't_util_heating': 'Chauffage urbain',
    't_view_all': 'Voir tout',
    't_waste': 'Déchets\n' +
      'Recyclage',
    't_waste_title': 'Déchets {0} Recyclage',
    't_waste_recycling': 'Déchets Recyclage',
    'Waste': 'Perte',
    't_water': 'Eau',
    't_wednesday': 'Mercredi',
    't_wellbeing': 'Bien-être',
    't_wholebuilding': 'Le bâtiment dans son ensemble',
    't_yes': 'Oui',
    't_yesterday': 'Hier',
    't_y_o_y': 'Année après année',
    't_y_o_y_dialog_text': '<p><strong>La variance cible</strong> fait référence à la performance d\'un actif depuis le début de l\'année, par rapport à la même période l\'année dernière pour un service public donné, affichée sous la forme d\'une variation en pourcentage d\'une année sur l\'autre. Si un objectif a été défini sur un actif dans SIERA pour l\'utilité, alors ce pourcentage est basé sur l\'année précédente.</p>',
    't_y_o_y_target': 'Depuis le début de l\'année, écart par rapport à l\'objectif',
    't_ytd': 'Depuis le début de l\'année, écart par rapport à l\'objectif',
    't_ytd_uppercase': 'Depuis le début de l\'année',
    't_show_targets': 'afficher les cibles',
    't_estimated': 'estimé',
    't_estimate': 'FR ESTIMATED',
    't_start_date': 'date de début',
    't_end_date': 'date de fin',
    't_year': 'année',
    't_reporting_year': 'FR Reporting Year',
    't_asset_values': 'FR Asset Values',
    't_fossil_fuel_exposure': 'FR Fossil Fuel Exposure',
    't_planning_permission_date': 'FR Planning Permission Date',
    't_epc_coverage': 'FR EPC Coverage',
    't_ped': 'FR PED',
    't_nzeb_threshold': 'FR NZEB Threshold',
    't_asset_floor_area': 'FR Asset Floor Area',
    't_total_raw_materials_weight': 'FR Total Raw Materials Weight',
    't_sustainable_raw_materials_weight': 'FR Sustainable Raw Materials Weight',
    't_total_horizontal_area': 'FR Total Horizontal Area',
    't_horizontal_artificial': 'FR Horizontal artificial',
    't_vertical_artificial': 'FR Vertical artificial',
    't_total_vertical_area': 'FR Total Vertical Area',
    't_artificial_horizontal_area': 'FR Artificial Horizontal Area',
    't_artificial_vertical_area': 'FR Artificial Vertical Area',
    't_asset_values_extended': ' ',
    't_fossil_fuel_exposure_extended': 'FR An asset is exposed to fossil fuels if it is involved in the extraction, storage, transport or manufacture of fossil fuels. This should be updated quarterly.',
    't_planning_permission_date_extended': 'FR  ',
    't_epc_coverage_extended': 'FR  ',
    't_nzeb_threshold_extended': 'FR A Nearly Zero-Energy Building is one which meets or exceeds an energy performance target calculated according to the appropriate national methodology, for EU nations. Non-EU nations will not have an applicable NZEB threshold.',
    't_asset_floor_area_extended': 'FR The gross internal area of the asset.',
    't_waste_management_extended': 'FR An asset has implemented waste management processes if it is equipped with facilities for waste sorting, and covered by a waste recovery or recycling contract.',
    't_total_raw_materials_weight_extended': 'FR The total weight of raw materials used in new construction or major redevelopment at the asset.',
    't_sustainable_raw_materials_weight_extended': 'FR Sustainable raw materials refers to materials which are recovered, recycled or bio-sourced.',
    't_total_horizontal_area_extended': 'FR This refers to the “plan” or “bird\'s eye” area of the plot, not the internal area.',
    't_total_vertical_area_extended': 'FR This refers to external, vertical surface area.',
    't_artificial_horizontal_area_extended': 'FR “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Horizontal Area.',
    't_artificial_vertical_area_extended': 'FR “Artificialisation” refers to surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls. This should be less than the reported Total Vertical Area.',
    't_missing_field_description': 'FR Missing Field Descriptions',
    't_picker_filter_value': '{0} mois jusquau {1} {2}',
    't_sustainable_tonnes': 'FR Sustainable tonnes',
    't_total_tonnes': 'FR Total tonnes',
    't_exposure_select': 'FR Select Exposure',
    't_picker_filter_value_single_month': '{0} mois à fin {1} {2}',
    't_variance_from_target': 'Écart par rapport à la cible / année précédente',
    't_rank': 'rang',
    't_under_recycling_target': 'Under recycling target for period',
    't_over_recycling_target': 'Over recycling target for period',
    't_est_savings': 'FR est. savings',
    't_add_note_dots': 'Ajouter une note...',
    't_done': 'Terminé',
    't_password_reset_success': 'Votre mot de passe a été réinitialisé',
    't_reset': 'Réinitialiser',
    't_auto_meter_readings': 'Relevés de compteurs automatiques (RCA)',
    't_auto_system_upgrades': 'Mises à niveau/remplacements du système d\'automatisation',
    't_composting_landscape': 'Environnement de compostage et/ou déchets alimentaires',
    't_cooling_tower': 'Tour de refroidissement',
    't_drip_irrigation': 'Irrigation goutte à goutte/intelligente',
    't_drought_tolerant_landscaping': 'Aménagement paysager tolérant à la sécheresse et indigène',
    't_high_efficiency_fixtures': 'Appareils à haut rendement / sec',
    't_installation_equipment': 'Installation d\'équipements et d\'appareils à haute efficacité',
    't_instructions': 'FR Instructions',
    't_bulk_add_template': 'FR Bulk Add Template',
    't_bulk_edit_template': 'FR Bulk Edit Template',
    't_consumption_loader': 'FR Consumption loader',
    't_installation_renewable': 'Installation d\'énergie renouvelable sur site',
    't_leak_detection_system': 'Système de détection de fuite',
    't_management_sys_upgrade': 'Mises à niveau/remplacements des systèmes de gestion',
    't_selected_asset_stranding': 'FR Selected asset CRREM Misalignment in ',
    't_asset_level_model_message': 'FR This will create a model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_meter_water_subsys': 'Compteur des sous-systèmes d\'eau',
    't_not_available': 'N/A',
    't_occupier_eng_tech': 'Implication de l\'occupant / technologies de l\'information',
    't_ongoing_waste_monitoring': 'Surveillance continue de la performance pour les déchets',
    't_onsite_waste_water_treatment': 'Traitement des eaux usées sur site',
    't_recycling': 'Recyclage',
    't_reuse_storm_water': 'Réutilisation des eaux pluviales et/ou des eaux grises',
    't_smart_grid_tech': 'Réseau électrique intelligent / technologies de construction intelligentes',
    't_sys_commissioning': 'Mise en service ou remise en service de systèmes',
    't_utility_type': 'Type de service',
    't_wall_roof_inst': 'Isolation des murs / toiture',
    't_waste_management': 'Gestion des déchets',
    't_waste_stream_audit': 'Audit sur les flux de déchets',
    't_window_replacement': 'Remplacements de fenêtres',
    't_heatmap_tooltip_content_txt': '{0} données manquantes pour {1} {2}',
    't_heatmap_tooltip_content_txt_partial': '{0} données manquantes pour',
    't_heatmap_tooltip_content_txt_none': '{0} Toutes les données collectées pour {1} {2}',
    't_missing_partial_data': 'Données partielles manquantes',
    't_delete': 'Supprimer',
    't_delete_action_title': 'Supprimer l\'action',
    't_delete_confirmation': 'Êtes-vous sûr(e) ?',
    't_go': 'Accéder',
    't_error_ok': 'OK',
    't_error_request_400': 'Une erreur est survenue lors du traitement de votre demande.',
    't_error_request_401': 'Vous ne disposez pas des autorisations suffisantes pour accéder à cette ressource',
    't_page_not_found': 'FR Page not found',
    't_page_not_found_reason': 'FR You\'ve asked for a page which doesn\'t exist in this application, or you don\'t have access to it. {contactEvora} for help.',
    't_page_auth_error': 'FR There was a problem logging in.',
    't_page_auth_error_reason': 'FR There was a problem authenticating your credentials. Please check them carefully and try again.',
    't_back_to_login': 'FR Try logging in again',
    't_error_user_account_locked': 'Le compte est verrouillé pour les prochaines {lockedDuration} secondes.',
    't_error_user_internal_login_issue': 'SIERA rencontre des problèmes de service. Veuillez réessayer plus tard.',
    't_password_expiry_info': 'Votre mot de passe a expiré. Veuillez créer un nouveau mot de passe.',
    't_password_must_be_different': 'Le nouveau mot de passe ne peut pas être le même que le mot de passe expiré',
    't_target_beaten': 'Cible dépassée !',
    't_lower_than_previous': 'Moins que l\'année précédente !',
    't_higher_than_previous': 'Plus que l\'année précédente',
    't_current': 'Actuel',
    't_target': 'Cible',
    't_previous': 'Précédent',
    't_variance': 'Variance',
    't_percentage_missing': '% de données manquantes',
    't_target_missed': 'Cible manquée',
    't_savings': 'Épargne',
    't_overspend': 'Dépassement de budget',
    't_annual_current_consumption': 'Consommation annuelle actuelle',
    't_annual_expected_consumption': 'Consommation annuelle attendue',
    't_agreed_action': 'Action convenue',
    't_applicable_action': 'Action applicable',
    't_action_under_review': 'Action en cours d\'examen',
    't_notes_lowercase': 'notes',
    't_add_variance_note': 'Ajouter une note pour expliquer l\'écart',
    't_delete_warning': 'Êtes-vous sûr de vouloir supprimer cette action ?',
    't_details': 'Détails',
    't_clear': 'Effacer',
    't_groups': 'FR Groups',
    't_my_groups': 'FR My Groups',
    't_edit_user': 'FR Edit user',
    't_add_photo': 'FR Add photo',
    't_name': 'FR Name',
    't_company': 'FR Company',
    't_role': 'FR Role',
    't_email_address': 'FR Email address',
    't_required_fields': 'FR Required fields ',
    't_save_exit': 'FR Save and exit',
    't_post': 'Publier',
    't_edited': 'modifié',
    't_close': 'Fermer',
    't_calendar': 'Calendrier',
    't_chart': 'Graphique',
    't_exclamation': 'Exclamation',
    't_hand_rightt': 'Index pointé',
    't_info': 'Info',
    't_no_notes': 'Aucune note à afficher',
    't_no_redirect_data': 'Aucune redirection des données du serveur',
    't_old_password': 'Ancien mot de passe',
    't_confirm_password': 'Confirmer le mot de passe',
    't_property': 'Propriété',
    't_refresh': 'Actualiser',
    't_show_hide_pass': 'Afficher/masquer le mot de passe',
    't_tick': 'Cocher',
    't_help': 'Besoin d\'aide',
    't_help_assistance': 'Si vous avez besoin d\'aide, cliquez ici.',
    't_blue': 'Données intégralement collectées',
    't_not_covered': 'Non couvert',
    't_consumption': 'Consommation',
    't_add_action_plan_in_bulk': 'FR Add action plans in bulk',
    't_edit_action_plan_in_bulk': 'FR Edit action plans in bulk',
    't_error_user_username': 'L\'e-mail est vide ou invalide.',
    't_landlord_procured': 'Fourni par le propriétaire',
    't_title_meter_view': 'Vue compteur',
    't_provider': 'Fournisseur',
    't_title_summary': 'Résumé',
    't_tenant_procured': 'Fourni par le locataire',
    't_yellow': 'Donnée estimée',
    't_source': 'Source',
    't_reading': 'Lecture',
    't_meters': 'Compteurs',
    't_action_happen': 'Quand l\'action aura lieu',
    't_action_completed': 'Lorsque l\'action est terminée',
    't_date_format_check': 'Ce format de date n\'est pas reconnu, veuillez vérifier',
    't_show_me': 'Montrez-moi',
    't_months': 'mois',
    't_month': 'mois',
    't_end_of': 'à la fin de',
    't_completed_action': 'Action achevée',
    't_review_date': 'Date de l\'examen',
    't_note_post_warning': 'Appuyez sur « Publier » pour ajouter votre note avant de fermer',
    't_warning': 'FR Warning',
    't_warning_asset_review': 'This asset is currently being reviewed by an Evora consultant. Contact support@evoraglobal.com for more information.',
    't_string': '-',
    't_dq_landlord_pdf': 'FR SIERA Data Quality Landlord.pdf',
    't_dq_tenant_pdf': 'FR SIERA Data Quality Tenant.pdf',
    't_dq_meter_pdf': 'FR SIERA Data Quality Meter.pdf',
    't_data_quality_zip': 'FR SIERA Data Quality.zip',
    't_performance_excel': 'FR SIERA Performance.xlsx',
    't_data_quality_excel': 'FR SIERA Data Quality .xlsx',
    't_area': 'FR Area',
    't_events_pfg_msg': 'FR Peformance may have been affected by these events',
    't_last_edit': 'FR Last edit',
    't_reports_create': 'FR Create Report',
    't_reports_ready': 'FR Ready',
    't_estimated_data_legend': 'FR Estimated data',
    't_incomplete_data_legend': 'FR Incomplete data',
    't_not_covered_data_legend': 'FR Not covered',
    't_add_details': 'FR Add details',
    't_completed_data_requirements':'FR Completed Data Requirements',
    't_reports_no_assets': 'FR No assets owned in the reporting year',
    't_reports_SFDR': 'FR {count} SFDR fields',
    't_reports_missing_required': 'FR Missing Required Fields',
    't_reports_missing_optional': 'FR Missing Optional Fields',
    't_reports_data_completeness': 'FR Data Completeness',
    't_reports_report_created_on': 'FR Report created on',
    't_reports_data_completeness_missing': 'FR Consumption Data Missing',
    't_reports_report_completeness': 'FR Report Completeness',
    't_reports_report_completeness_missing': 'FR {count} Assets are missing required data.',
    't_reports_percentage_complete': 'FR {percentage}% complete',
    't_reports_percentage_complete_consumption_data': 'FR {percentage}% complete consumption data',
    't_reports_create_report_header': '{year} FR Report',
    't_reports_save': 'FR Save Report',
    't_reports_assetplanningpermissiondate_not_found': 'FR Planning Permission Date',
    't_reports_assetnzeb_not_found': 'FR NZEB Threshold',
    't_reports_assetped_not_found': 'FR Primary Energy Demand',
    't_reports_giaM2_not_found': 'FR GIA (M2)',
    't_reports_gresbmgtstatus_not_found': 'FR GRESB Management Status',
    't_reports_artificialhorizontalarea_not_found': 'FR Artificial Horizontal Area',
    't_reports_artificialverticalarea_not_found': 'FR Artificial Vertical Area',
    't_reports_totalhorizontalarea_not_found': 'FR Total Horizontal Area',
    't_reports_totalverticalarea_not_found': 'FR Total Vertical Area',
    't_reports_gav_not_found': 'FR GAV',
    't_reports_fossilfuelexposure_not_found': 'FR Fossil Fuel Exposure',
    't_reports_wasteproduction_not_found': 'FR Waste Data',
    't_reports_constructionmaterialweight_not_found': 'FR Resource Consumption Data',
    't_reports_assetepc_not_found': 'FR EPC not found',
    't_reports_assetepc_not_valid': 'FR EPC not valid',
    't_reports_assetepc_insufficient_coverage': 'FR EPC insufficient coverage',
    't_reports_assetepc_not_found_msg': 'FR No EPCs were found for this asset, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset, or indicate that it is exempt from these requirements below.',
    't_reports_assetepc_not_valid_msg': 'FR The EPCs at this asset are not valid for the reporting period, so it will be categorised as energy-inefficient. If this is incorrect, provide valid EPC(s) for the asset.',
    't_reports_assetepc_insufficient_coverage_msg': 'FR The EPCs at this asset do not cover sufficient floor area, so it will be categorised as energy-inefficient. If this is incorrect, provide additional EPC(s), or indicate that units are EPC exempt.',
    't_explanation': 'FR Explanation',
    't_explanation_placeholder': 'FR Type in explanation',
    't_actions_taken': 'FR Actions Taken',
    't_actions_taken_placeholder': 'FR Type in actions taken',
    't_adverse_impact': 'FR Adverse Impact',
    't_fossil_fuels_exposure': 'FR Fossil Fuels Exposure',
    't_energy_efficiency': 'FR Energy Efficiency',
    't_energy_consumption': 'FR Energy Consumption',
    't_resource_consumption': 'FR Resource Consumption',
    't_adverse_impact_fossil_fuels': 'FR Exposure to fossil fuels through real estate assets.',
    't_adverse_impact_energy_efficiency': 'FR Exposure to energy-inefficient real estate assets.',
    't_adverse_impact_ghg_emissions': 'FR Greenhouse Gas Emissions',
    't_adverse_impact_energy_consumption': 'FR Energy Consumption Intensity',
    't_adverse_impact_waste': 'FR Waste production in operations',
    't_adverse_impact_resource_consumption': 'FR Raw materials consumption for new construction and major renovations',
    't_adverse_impact_biodiversity': 'FR Land artificialisation',
    't_impact_value': 'FR Impact Value',
    't_impact_value_fossil_fuels': 'FR Share of investments in real estate assets involved in the extraction, storage, transport or manufacture of fossil fuels.',
    't_impact_value_energy_efficiency': 'FR Share of investments in energy-inefficient real-estate assets',
    't_impact_value_ghg_emissions': 'FR Scope 1, 2, 3 and Total emissions generated by real estate assets',
    't_impact_value_energy_consumption': 'FR Energy consumption in GWh of owned real estate assets per square meter of gross internal area',
    't_impact_value_waste': 'FR Share of real estate assets not equipped with facilities for waste sorting and not covered by a waste recovery or recycling contract',
    't_impact_value_resource_consumption': 'FR Share of raw building materials (excluding recovered, recycled and biosourced) compared to the total weight of building materials used in new construction and major renovations',
    't_impact_value_biodiversity': 'FR Share of non-vegetatedsurface area (surfaces that have not been vegetated in ground, as well as on roofs, terraces and walls) compared to the total surface area of the plots of all assets',
    't_lease': 'FR Lease',
    't_back_t_a_users': 'FR Back to all users',
    't_members': 'FR Members',
    't_groups_none': 'FR No Groups Found',
    't_assets_none': 'FR No Assets Found',
    't_selected': 'FR selected',
    't_access': ' to access',
    't_upload': 'FR Upload',
    't_add_asset': 'FR Add asset',
    't_upload_select_or_drop_file': 'FR Select or drop a file',
    't_upload_here_jpg': 'FR here (JPG)',
    't_upload_image': 'FR Upload image',
    't_upload_footer_info': 'FR Image file must be a jpg/png and no bigger than 2mb in size',
    't_choose_assets_for': 'FR Choose resources for',
    't_admin': 'FR Admin',
    't_administrator': 'FR Administrator',
    't_user1': 'FR User1',
    't_user': 'FR User',
    't_users': 'FR Users',
    't_add_user': 'FR Add user',
    't_recycling_target_beaten': 'FR Recycling target beaten',
    't_more_recycled_than_previous_year': 'FR More recycled than previous year!',
    't_recycling_target_missed': 'FR Recycling target missed',
    't_less_recycled_than_previous_year': 'FR Less recycled than previous year',
    't_next_choose_groups': 'FR Next - Choose Groups',
    't_next_choose_assets': 'FR Next - Choose Assets',
    't_choose_groups_for_new_user': 'FR Choose the users that will have access to this group',
    't_choose_groups_for_update_user': 'FR Choose the groups {0} has access to',
    't_choose_users_for_update_group': 'FR Choose the users {0} has access to',
    't_choose_users_who_will_be_able_to_access_group': 'FR Choose users who will be able to access  ‘{0}’',
    't_find_group': 'FR Find group',
    't_add_new_group': 'FR Add new group',
    't_created': 'FR Created',
    't_choose_assets_for_update_user': 'FR Choose the assets {0} has access to',
    't_choose_assets_for_new_user': 'FR Choose the assets this user will have access to',
    't_last_login': 'FR Last login',
    't_add_new_user': 'FR Add new user',
    't_find_user': 'FR Find user',
    't_home': 'FR Home',
    't_users_not_found': 'FR Sorry we couldn\'t find any Users.',
    't_title_cannot_post_user_asset_groups': 'Add user asset groups failed',
    't_title_cannot_put_user_asset_groups': 'Update user asset groups failed',
    't_contact_problem_access': 'FR Problem getting access',
    't_full_name': 'FR Full name',
    't_create_siera_account': 'FR Create your SIERA account',
    't_password_not_match': 'FR Passwords do not match',
    't_title_cannot_signup': 'FR Signup failed',
    't_title_cannot_post_user_asset_access': 'Add user asset access failed',
    't_title_cannot_put_user_asset_access': 'Update user asset access failed',
    't_retail': 'FR Retail',
    't_office': 'FR Office',
    't_industrial': 'FR Industrial',
    't_residential': 'FR Residential',
    't_hotel': 'FR Hotel',
    't_lodgingleisurerecreation': 'FR Lodging Leisure Recreation',
    't_education': 'FR Education',
    't_technologyscience': 'FR Technology Science',
    't_healthcare': 'FR Healthcare',
    't_mixeduseoffice': 'FR Mixed Use Office',
    't_asset_details': 'FR Asset details',
    't_select_sector': 'FR Select sector',
    't_select_gresb_sector': 'FR Select GRESB sector',
    't_building_utilities': 'FR Building utilities present',
    't_select_building_utilities': 'FR Select building utilities present',
    't_gav_evaluation_date': 'FR GAV evaluation date',
    't_operation_control': 'FR Operational control',
    't_select_operational_control': 'FR Select operational control',
    't_building_details': 'FR Building details',
    't_postcode': 'FR Postcode',
    't_city': 'FR City',
    't_select_city': 'FR Select a city',
    't_select_country': 'FR Select a country',
    't_select_region': 'FR Select a region',
    't_select_date': 'FR Select date',
    't_select_fund': 'FR Select a fund',
    't_asset_ownership': 'FR Fund ownership',
    't_sold_date': 'FR Sold date',
    't_year_built': 'FR Year built',
    't_select_asset_status': 'FR Select asset\'s current status',
    't_current_status': 'FR Current status',
    't_lifecycles_explanation': 'FR Ensure accurate reporting and data calculations by tracking asset events.',
    't_lifecycles': 'FR Lifecycle',
    't_current_status_tooltip': 'FR What is your asset\'s current stage in its ownership lifecycle?',
    't_asset_ref_tooltip': 'FR A unique name you assign to assets for easy identification within Siera.',
    't_land': 'FR Land',
    't_standing_investment': 'FR Standing Investment',
    't_new_construction': 'FR New Construction',
    't_major_renovation': 'FR Major Renovation',
    't_static_reporting_data': 'FR Static reporting data',
    't_periodic_reporting_details': 'FR Periodic reporting details',
    't_key_dates': 'FR Key dates',
    't_epc': 'FR EPC',
    't_users_groups': 'FR Users & Groups',
    't_asset_name_tc': 'FR Asset Name',
    't_asset_reference_tc': 'FR Asset Reference',
    't_asset_name': 'FR Asset name',
    't_asset_reference': 'FR Asset reference',
    't_find_address': 'FR Find address',
    't_add_address_manually': 'FR Add address manually',
    't_number_identifier': 'FR Number / Identifier',
    't_street': 'FR Street',
    't_town_city': 'FR Town/City',
    't_county': 'FR County',
    't_country': 'FR Country',
    't_region': 'FR Region',
    't_postcode_zip': 'FR Postcode/ZIP',
    't_sector_type': 'FR Sector type',
    't_gross_asset_value': 'FR Gross Asset Value (GAV)',
    't_fri': 'FR Full repairing and insuring lease',
    't_floor_areas': 'FR Floor Areas',
    't_gia': 'FR Gross Internal Area (GIA)',
    't_nla': 'FR Net Lettable Area (NLA)',
    't_cpa': 'FR Common Parts Area (CPA)',
    't_ext': 'FR External Area (EXT)',
    't_units': 'FR Units',
    't_units_desc': 'FR Do you want to be able to add data for units? (You can do this later)',
    't_next_add_key_dates': 'FR Next - Add Key dates',
    't_form_error_message': 'FR Please fill all the required fields',
    't_asset_existing_group': 'FR This asset is part of a selected fund or group',
    't_organisation': 'FR Organisation',
    't_user_warning_message': 'FR Are you sure you want to cancel this action?',
    't_user_invited_to_join_siera': 'FR {0} has been invited to join SIERA',
    't_user_creation_confirmation_popup_title': 'FR Confirmation',
    't_user_revocation_successful': 'FR {0} has been successfully revoked',
    't_resend_invite': 'FR Resend invite',
    't_instance': 'FR Instance',
    't_instance_different': 'FR Please select an instance which is not your current one.',
    't_change_instance': 'FR Change instance',
    't_change_instance_explanation': 'FR When you change of instance you will be automatically logged out and redirected to the correct instance login screen where you can use your usual credentials.',
    't_wrong_instance': 'FR Switch instance?',
    't_wrong_instance_explanation': 'FR You are trying to access an instance which is not your active one. Do you want to switch instances?',
    't_continue_to': 'FR Re-login to',
    't_switch_to': 'FR Yes, switch to',
    't_could_not_find_groups': 'FR Sorry we couldn\'t find any Groups.',
    't_developer': 'FR Developer',
    't_delete_group': 'FR Delete Group',
    't_description': 'FR Description',
    't_groups_not_found': 'FR Sorry we couldn\'t find any Groups.',
    't_view_all_resources': 'FR View all {0} resources',
    't_view_all_assets': 'FR View all {0} assets',
    't_fund_name': 'FR Fund name',
    't_investment_stage': 'FR Investment stage',
    't_search_scheme_asset_name': 'FR Search by scheme and asset name',
    't_green_building_certificates': 'FR Green Building Certificates',
    't_energy_rating_certification': 'FR Energy Rating Certification', 
    't_scheme': 'FR Scheme',
    't_reference_no': 'FR Reference no',
    't_rating': 'FR Rating',
    't_score': 'FR Score',
    't_unit': 'FR Unit',
    't_certified_floor_area': 'FR Certified floor area',
    't_valid_from_date': 'FR Valid from date',
    't_file_upload': 'FR File upload',
    't_uploaded_date': 'FR Upload date',
    't_gav': 'FR GAV',
    't_total_floor_area': 'FR Total floor area',
    't_contains': 'FR Contains',
    't_total_floor_area_gia': 'FR Total floor area (GIA)',
    't_financial_year_starts': 'FR Financial year starts',
    't_carbon_emissions': 'FR Carbon Emissions',
    't_energy_intensity': 'FR Energy intensity',
    't_recycled_waste': 'FR Recycled Waste',
    't_gap_filled_data': 'FR gap-filled data',
    't_below_target': 'FR below target',
    't_above_target': 'FR above target',
    't_key_facts': 'FR Key facts',
    't_funds': 'FR Funds',
    't_my_organisations': 'FR My Organisations',
    't_net_zero_carbon': 'FR Net Zero Carbon',
    't_cco_fund_model': 'FR CCO Fund - Model',
    't_data-source_nzc': 'FR Data source: SIERA',
    't_kg_co2_year': 'FR kgCO₂e/m²/year',
    't_kwh_m2_year': 'FR kWh/m²/year',
    't_bau_ghg_intensity': 'FR Business as usual (BAU)',
    't_scientific_ghg_intensity': 'FR Science based target (1.5C)',
    't_scientific_ghg_intensity(2.0)': 'FR Science based target (2.0C)',
    't_no_organisations_message': 'FR No Organisations Found',
    't_rise': 'FR rise',
    't_fall': 'FR fall',
    't_next_choose_funds': 'FR Next - Choose Funds',
    't_find_fund': 'FR Find fund',
    't_choose_funds_for_user': 'FR Choose the funds this user will have access to',
    't_choose_funds_for_update_user': 'FR Choose the funds {0} has access to',
    't_proportion_missing_data': 'FR Portion of missing fund data',
    't_incomplete': 'FR Incomplete',
    't_total_missing': 'FR Total missing',
    't_revoke_access': 'FR Revoke access',
    't_grant_access': 'FR Grant access',
    't_user_access_revoked': 'FR This user\'s access has been revoked',
    't_user_revoke_confirm_message': 'FR This user will be deactivated and will no longer be able to log in.',
    't_actions_by_assets': 'FR Actions by asset ({0})',
    't_overdue': 'FR Overdue',
    't_items_per_page': 'FR Items per page',
    't_of': 'FR of',
    't_total_costs': 'FR Total costs',
    't_non_recoverable': 'FR Non-recoverable',
    't_un_costed': 'FR Un-costed',
    't_gap_filled_data_above_target': 'FR Gap-filled data (above target)',
    't_actual_data_above_target': 'FR Actual data (above target)',
    't_actual_data_legend': 'FR Actual data',
    't_gap_filled_data_legend': 'FR Gap-Filled Data',
    't_over_target_legend': 'FR Over target',
    't_show': 'FR Show',
    't_quarterly_data': 'FR Quarterly data',
    't_monthly_data': 'FR Monthly data',
    't_how_we_calculate': 'FR How we calculate this',
    't_fund_graph_carbon_explanation': 'FR Graph showing total carbon emissions for scopes 1, 2 and 3.',
    't_site_admin': 'FR Site admin',
    't_my_account': 'FR My account',
    't_my_profile': 'FR My profile',
    't_aggregated_performance_assets_model': 'Performances agrégées pour les actifs utilisés dans le modèle',
    't_agreed_overlay_text': 'FR In the current NZC model, assetCountWithNoAgreedActions out of totalAssets assets have no agreed energy-saving actions.',
    't_action_based_overlay_text': 'FR In the current NZC model, all totalAssets assets have at least one energy-saving action defined.',
    't_asset_error_message': 'FR Selected assets does not have sufficient data',
    't_aggregated_data_quality_assets_model': 'Qualité des données agrégées pour les actifs utilisés dans le modèle',
    't_based_on_baseline_year': 'Basé sur l\'année de référence',
    't_based_on_year': 'FR Based on year',
    't_carbon_intensity': 'Intensité carbone',
    't_cost_intensity': 'Intensité des coûts',
    't_co2_emissions': 'Émissions de CO₂e',
    't_feedback-panel-label': 'FR How could we improve this page?',
    't_feedback_form_header': 'FR Your feedback',
    't_feedback_form_info': 'FR Would you be happy to speak to us in more depth about your experience of using SIERA?',
    't_feedback_form_label': 'FR Yes, I am happy to be contacted to give more feedback',
    't_target_delta': 'FR target/delta',
    't_sector': 'FR Sector',
    't_no_data_available': 'FR There is no data available',
    't_feedback_success': 'FR Successfully Sent the feedback',
    't_add_feedback_failed': 'FR Add user feedback failed',
    't_about_scopes': 'À propos des étendues',
    't_about_scopes_info': 'Ces mesures des émissions de carbone illustrent l\'impact des activités nécessaires à l\'exploitation directe d\'un immeuble, c\'est-à-dire le chauffage, l\'éclairage, etc. Elles incluent les émissions des locataires (scope 3) pour les services publics utilisés par les locataires de l\'immeuble, mais n\'incluent pas les activités prolongées nécessaires à l\'activité du locataire.',
    't_more_details': 'Plus de détails',
    't_user_last_loggedIn_at': 'FR Last logged in at {0} on {1}',
    't_total_data_missing': 'FR Total data missing',
    't_landlord_data_missing': 'FR Landlord data missing',
    't_tenant_data_missing': 'FR Tenant data missing',
    't_total_waste': 'Déchets totaux',
    't_water_intensity': 'Intensité de l\'eau',
    't_assets_wo_agreed_action': 'FR Assets without agreed actions',
    't_assets_wo_completed_action': 'FR Assets without completed actions',
    't_coverage_by_floor_area': 'FR Floor area coverage',
    't_valid_certs_by_floor_area': 'FR Valid certificates by floor area',
    't_expire_within_12_months': 'FR Expire within 12 months',
    't_no_certs': 'FR No certificates found',
    't_top_impact_cat': 'FR Top 5 impact categories',
    't_user_not_logged_in': 'FR User has not logged in yet.',
    't_total_data': 'FR Total data',
    't_landlord_proc_data': 'FR Landlord-procured data',
    't_tenant_proc_data': 'FR Tenant-procured data',
    't_landlord_proc_building': 'FR Landlord procures whole building',
    't_tenant_proc_building': 'FR Tenant procures whole building',
    't_otherfuelsandthermals': 'FR Other Fuels & Thermals',
    't_funds_none': 'FR No Funds Found',
    't_funds_performance_cost_higher': 'FR higher than previous period',
    't_funds_performance_cost_lower': 'FR lower than previous period',
    't_gap_filled_data_NA': 'FR gap-filling not available',
    't_only_for_annual_data': 'FR Only available for annual data.',
    't_performance_energy_intensity_coming_soon': 'FR Performance for Energy Intensity coming soon.',
    't_non_recycled_waste': 'FR Non-recycled waste',
    't_total_carb_emissions': 'FR total carbon emissions',
    't_total_elec_used': 'FR total electricity used',
    't_total_gas_fuels_thermals': 'FR total gas fuels & thermals',
    't_total_water_used': 'FR total water used',
    't_total_recycled_waste': 'FR total recycled waste',
    't_fund_rise_than_previous_period': 'augmenter par rapport à la période précédente!',
    't_fund_fall_than_previous_period': 'tomber sur la période précédente!',
    't_estimated_saving': 'économie estimée',
    't_recycledwaste': 'Déchets recyclés',
    't_nzc_available_siera': 'FR Net Zero Carbon available in SIERA',
    't_water_units': 'm³',
    't_assets_in_the_model': 'actifs dans le modèle',
    't_date_of_export': 'FR Date of export',
    't_target_pathway_info': 'FR Target pathways allow you to define a year-on-year plan for % carbon reduction for your model,\n relative to your baseline year.',
    't_action_based_target_pathway': 'FR Action-based pathways aggregate all of the energy-saving actions that have been defined for the assets in the current model and present them as a single pathway for your fund.',
    't_science_based_target_pathway': 'FR This is an area weighted decarbonisation pathway based on your selected assets aligned to the Paris Climate Goals. This shows the carbon intensity required to keep in line with the commitments to limit global warming.',
    't_custom_target_pathway': 'FR Custom target pathways allow you to specify your own targets over time for assets in your model.',
    't_target_pathway_1': 'FR Target Pathway 1',
    't_action_based_carbon_pathway': 'FR Action based pathway',
    't_action_based_energy_intensity_pathway': 'FR Action based energy intensity pathway',
    't_action_based_pathways': 'FR Action-based pathways',
    't_energy_saving_action': 'FR Use energy-saving actions to generate a NZC pathway',
    't_agreed_actions_count': 'FR {0} Agreed actions (required)',
    't_applicable_actions_count': 'FR {0} Applicable actions (recommended)',
    't_science_based_target': 'FR CRREM Science Based Targets (SBT)',
    't_SBT_option_1': 'FR 1.5C SBT',
    't_SBT_option_2': 'FR 2.0C SBT',
    't_custom_target_pathways': 'FR Custom target pathways',
    't_tp_stranding_year': 'FR CRREM Misalignment year in ',
    't_show_progress_towards_target_for': 'FR Show progress towards target for ',
    't_cumulative': 'FR Cumulative',
    't_apply': 'FR Apply',
    't_grid_decarbonisation': 'FR grid decarbonisation',
    't_title_cannot_create_target_pathway': 'FR Create target pathway failed',
    't_improvement': 'FR Improvement',
    't_epc_available_siera': 'FR Detailed EPC analysis available in SIERA',
    't_waste_utility': 'Déchets',
    't_model': 'Modèle',
    't_models': 'Des modèles',
    't_create_new_model': 'Créer un nouveau modèle',
    't_open_model': 'Ouvrir un modèle',
    't_share_model': 'FR Share model',
    't_link': 'FR Link',
    't_copy_link': 'FR Copy link',
    't_link_copied': 'FR Link copied',
    't_share': 'FR Share',
    't_duplicate_model': 'Modèle en double',
    't_export_config_data': 'Données de configuration d\'exportation',
    't_import_config_data': 'Importer des données de configuration',
    't_search': 'Chercher',
    't_open': 'Ouverte',
    't_no_models_are_created_yet': 'Aucun modèle n\'est encore créé',
    't_default_model': 'Définir le modèle par défaut',
    't_delete_model': 'Supprimer le modèle',
    't_delete_yes_cancel': 'supprime ça! / /',
    't_bau_stranding': 'FR BAU CRREM Misalignment',
    't_no_model': 'FR No models found',
    't_create_new_model_para': 'Cela créera un modèle à partir de tous les actifs actuels et valides de ce fonds. Tous les actifs qui ne disposent pas de suffisamment de données sur la consommation se verront appliquer une référence sectorielle et nationale.',
    't_create': 'Créer',
    't_name_required': 'Le nom est requis.',
    't_save_changes': 'Sauvegarder les modifications',
    't_model_name_not_valid': 'FR Enter a valid model name',
    't_filter': 'Filtre',
    't_all_sectors': 'FR All sectors',
    't_all_countries': 'FR All countries',
    't_assets_filter_result': 'FR {0} out of {1} assets will be displayed',
    't_assets_filter_count': 'FR filters selected:',
    't_assets_filter_title': 'FR Filter',
    't_about_gap_filled_data': 'FR About gap-filled data',
    't_gap_filled_data_dialog_content': '<p>FR Gap-filling missing data is less accurate than using complete\nactual data, but does allow users to\nsee an indicative, realistic picture\nof a fund or asset\'s performance.</p>',
    't_default_model_delete': 'FR Default models cannot be deleted. \nTo delete this Model, set another model as the Default model, then return to this model\'s settings and select delete.',
    't_no_results': 'FR No results found.',
    't_no_graph_data': 'FR No graph data',
    't_getting_scope_data': 'FR Getting Scope Data...',
    't_creating_default_scope': 'FR Creating default scope...',
    't_rise_over_previous_period': 'FR rise over previous period',
    't_sort': 'Trier',
    't_lowest_first': 'Le plus bas en premier',
    't_highest_first': 'Le plus élevé d\'abord',
    't_nzc_data_missing': 'FR Data missing',
    't_nzc_carbon_intensity': 'FR Carbon intensity',
    't_current_action_plan': 'FR Current Action Plan',
    't_current_epc_analysis': 'FR Current EPC Analysis',
    't_sold': 'FR SOLD',
    't_data_warning': 'FR DATA WARNING',
    't_siera_experience_feedback': 'FR I\'d be happy to speak in more depth about my experience of using SIERA',
    't_assets_not_in_model': 'FR assets are not included in this NZC model',
    't_reason_assets_not_in_model': 'FR These may include assets that have been sold, failed NZC validation or manually removed from the model.',
    't_view_these_assets': 'FR View these assets',
    't_export_model_explanation_text': 'FR You can manually change the utility consumption amounts for each asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_model_explanation_text_asset': 'FR You can manually change the utility consumption amounts for an asset in the model by downloading the configuration as an Excel file, changing it and uploading the changes back to the model',
    't_export_file_error_message': 'FR The export file name must not contain more than 50 characters',
    't_top': 'FR Top',
    't_import_model_explanation_text': 'FR To import asset data from Excel you must use the {0} template',
    't_import': 'FR Import',
    't_drag_file': 'FR Drag file to upload, or',
    't_select_file': 'FR Select a file',
    't_import_create_explanation': 'FR What do you want the new NZC model to be called?',
    't_upload_success_msg': 'FR has been successfully uploaded',
    't_upload_error_msg': 'FR There are problems with your file',
    't_row': 'FR Row',
    't_copy_clipboard': 'FR Copy to clipboard',
    't_select_valid_file': 'FR Select a valid file',
    't_copied': 'FR Copied',
    't_loading': 'FR Loading',
    't_procurement_tabs_explanation_title': 'FR What do these categories mean?',
    't_data_categories': 'FR Data Categories',
    't_about_procurement_data_categories': 'FR <p><b>Actual:</b> consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_duplicate_model_para': 'FR This will create a duplicate model with all of the assets from the current model. Any assets which do not have enough consumption data will have a sector and country benchmark applied.',
    't_asset_level_duplicate_model_para': 'FR This will create a duplicate model from all applicable and agreed actions related to this asset. If the asset does not have enough consumption data, it will have a sector and country benchmark applied.',
    't_delete_target_pathway_title': 'FR Delete Target Pathway',
    't_delete_target_pathway_message': 'FR Are you sure you want to delete this pathway?',
    't_add_another_target_pathway': 'FR Add another Target Pathway',
    't_add_a_target_pathway': 'FR Add a Target Pathway',
    't_target_pathway': 'FR Target pathway',
    't_milestone_years': 'FR Milestone years',
    't_group_leaving_confirmation': 'FR Thanks, Admin have been sent your request and we will be back in touch shortly',
    't_group_reason': 'FR What is your reason for leaving the group?',
    't_request': 'FR Request',
    't_leave_group': 'FR Request to leave the group',
    't_add_group': 'FR Create new Group',
    't_target_warning': 'FR The cumulative amount is 100% and cannot be increased. Please revise the reduction percentages.',
    't_chart_options': 'FR Chart options',
    't_plot_data_assets': 'FR Plot data for individual assets',
    't_display_benchmark': 'FR Display benchmark',
    't_data_source': 'FR Data source',
    't_show_progress_relative': 'FR Show progress relative to target for',
    't_base_line_year': 'FR Baseline year',
    't_raw_data': 'FR Raw data',
    't_siera': 'FR SIERA',
    't_imported': 'FR Imported',
    't_uplifted_data': 'FR Uplifted data',
    't_uplifted_estimated_data': 'FR Uplifted/estimated data',
    't_benchmark_data': 'FR Benchmarked data',
    't_complete_data': 'FR Complete data',
    't_choose_assets_group_for_update_user': 'FR Choose assets to include in ‘{0}’',
    't_choose_assets_group_for_new_user': 'FR Choose assets for this group to access',
    't_previous_period': 'FR Previous period',
    't_this_period': 'FR This period',
    't_gap_filled': 'FR Gap filled',
    't_combined': 'FR Combined',
    't_actual_and_supplier_estimated': 'FR Actual & supplier estimated',
    't_recycled_waste_previous': 'FR Recycled waste (previous)',
    't_group_name': 'FR Group name',
    't_email_leave_group': 'FR To request to leave this group, please email',
    't_data_shown': 'FR Data shown',
    't_show_details': 'FR Show details',
    't_hide_details': 'FR Hide details',
    't_view_asset': 'FR View asset',
    't_gia_small_form': 'FR GIA',
    't_asset_ref': 'FR Asset ref',
    't_stranding_year': 'FR CRREM Misalignment year',
    't_energy_saving': 'FR Energy-saving actions',
    't_target_stranding_year': 'FR Target pathway CRREM Misaligned in ',
    't_bau_stranding_year': 'FR BAU CRREM Misalignment in ',
    't_next_users': 'FR Next - Choose Users',
    't_delete_group_msg': 'FR Are you sure you want to delete this group?',
    't_edit_group': 'FR Edit group : ',
    't_all_assets': 'FR All assets',
    't_not_included_in_model': 'FR Not included in current NZC model',
    't_including_gap_filled': 'FR Including gap-filled data',
    't_excluding_gap_filled': 'FR Excluding gap-filled data',
    't_asset_without_energy_saving_action': 'FR Assets with no energy saving actions specified',
    't_sold_assets': 'FR Sold assets',
    't_sold_label': 'FR Asset sold',
    't_asset_status': 'FR Asset status',
    't_no_data_for_previous_period': 'FR no data for previous period',
    't_x_axis_scale': 'FR X-axis scale',
    't_y_axis_scale': 'FR Y-axis scale',
    't_autoscale': 'FR Autoscale',
    't_from': 'FR From',
    't_to': 'FR to',
    't_min': 'FR Min',
    't_max': 'FR Max',
    't_selected_asset': 'FR Selected asset',
    't_no_gresb_sector_error_message': 'FR Asset has no GRESB Sector or Country defined',
    't_asset_data_missing_message': 'FR Asset has critical information missing',
    't_asset_sold_date_message': 'FR Asset sold in',
    't_more_recycled': 'FR more recycled than previous period',
    't_less_recycled': 'FR less recycled than previous period',
    't_required_group_field': 'FR Required field',
    't_form_group_error_message': 'FR Please fill the required field',
    't_upload_nzc_data_failed': 'FR Upload NZC import data failed',
    't_nzc_file_uploaded_success': 'FR {0} file successfully uploaded',
    't_default_model_name': 'FR Default model',
    't_metric': 'FR Metric',
    't_imperial': 'FR Imperial',
    't_energy_intensity_popup_header': 'FR Coming soon',
    't_energy_intensity_popup_body': 'FR Detailed performance view for Energy Intensity coming soon.',
    't_epc_analysis_popup_header': 'FR Coming soon',
    't_epc_analysis_popup_body': '<p> FR Detailed EPC analysis will be available soon and is currently  <a>available in SIERA </a> </p>',
    't_model_notes': 'FR Model notes',
    't_setting_default_model_failed': 'FR Setting model as default failed',
    't_set_as_default': 'FR Set as Default Model',
    't_set_as_default_info': 'FR This is the model that is displayed on the fund dashboard, and will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_set_as_default_asset_info': 'FR This will be the first NZC model viewed by SIERA users. We recommend using your ‘best’ model as the default.',
    't_nzc_default_text': 'FR NZC default',
    't_unable_to_plot_NZC_chart': 'FR Unable to plot NZC chart.',
    't_unable_to_plot_NZC_chart_Info': 'FR No valid assets are available. Assets in this fund must have GRESB Sector and Country defined in order to be included in NZC calculations.',
    't_unable_to_plot_require_help': 'FR Please {contactEvora} if you require help.',
    't_contact_Evora': 'FR contact Evora',
    't_Contact_Evora': 'FR Contact Evora',
    't_model_no_data_available': 'FR No data available',
    't_select_target_pathway': 'FR Select Target Pathway',
    't_define_target_pathway': 'FR Define a custom target pathway',
    't_name_must_not_exceed_100_characters': 'FR The model name must not contain more than 100 characters',
    't_no_meter_information': 'FR No meter information.',
    't_no_assets': 'FR 0 assets',
    't_show_stranding_dates': 'FR Show CRREM Misalignment dates',
    't_default': 'FR Default',
    't_current_model': 'FR Current model',
    't_based_on': 'FR Based on',
    't_past_3_months': 'FR Past 3 months',
    't_past_6_months': 'FR Past 6 months',
    't_current_year_till_previous_month': 'FR Current year till previous month',
    't_model_with_same_name_exists': 'FR Model with the same name already exists.',
    't_apply_filter_view_these_assets': 'FR Apply Filter to view these assets',
    't_session_expiry': 'FR Your session is going to expire soon. Would you like to log out?',
    't_session_expiry_warning': 'FR For security reasons, we\'ll log you out in {0} unless you want to stay logged in.',
    't_session_expiry_title': 'FR Do you want to stay logged in?',
    't_stay_logged_in': 'FR Stay logged in',
    't_log_out_now': 'FR Log out now',
    't_jpeg': 'FR JPEG',
    't_svg': 'FR SVG',
    't_currency': 'FR Currency',
    't_nzc_session_model_deleted': 'FR {0} was deleted and cannot be displayed.  You are now viewing the default NZC model instead.',
    't_estimated_savings': 'FR Estimated Savings',
    't_procured_by': 'FR Procured by',
    't_area_covered': 'FR Area Covered',
    't_shared_services': 'FR Shared services',
    't_scope_index': 'FR Scope {0}',
    't_import_model_explanation_note_link': 'FR To import asset data from Excel you must use the {link} template.',
    't_import_model_explanation_note_description': 'FR Uploaded data is only used in the new NZC model that is created - it does not overwrite any data currently in SIERA',
    't_import_model_explanation_note_foundName': 'FR You can only upload data for assets that belong to the {fundOrAssetName} fund',
    't_btn_add': 'FR Add',
    't_btn_update_and_add': 'FR Update and add',
    't_gresb_measure_water': 'FR Performed a technical building assessment to identify water efficiency improvements',
    't_gresb_measure_waste': 'FR Performed a technical building assessment to identify waste efficiency improvements',
    't_gresb_measure_energy': 'FR Performed a technical building assessment to identify energy efficiency improvements',
    't_nzc_data_availability': 'FR Data availability',
    't_valid_ratings_by_floor_area': 'FR Valid scores by floor area',
    't_certified_assets_by_floor_area': 'FR Certified assets by floor area',
    't_ratings_last_sync_on': 'FR Scores last synced on {0}',
    't_certified': 'FR certified',
    't_energy_star_analysis': 'FR Energy Star Analysis',
    't_energy_star_score': 'FR Energy Star Score',
    't_energy_star_last_synced': 'FR This score was last synced from Energy Star Portfolio Manager on {0}.',
    't_kg_co2_m2_yr': 'FR kgCO₂e/m²/yr',
    't_kg_co2_yr': 'FR kgCO₂e/yr',
    't_kWh_m2_yr': 'FR kWh/m²/yr',
    't_energy_star_set': 'FR Set up your Energy Star integration to get this data',
    't_post_note_warning_message': 'FR Hit Post to add your note before closing',
    't_energy_star_integration': 'FR Energy Star Integration',
    't_es_sub_text': 'FR Integrating SIERA with your Energy Star Portfolio Manager will allow SIERA to extract and display energy ratings for your Assets.',
    't_learn_more': 'FR Learn more',
    't_es_step_title': 'FR Step {0} of {1}: {2}',
    't_es_step_one': 'FR Log into ES Portfolio Manager and add Evora_Siera as a contact',
    't_es_step_two': 'FR Enter your ES Portfolio Manager account ID',
    't_es_step_three': 'FR Share properties in ES Portfolio Manager with full access',
    't_es_step_four': 'FR Choose which Assets to extract ratings for',
    't_es_step_one_sub_text': 'FR {0} and add Evora_Siera as a new contact.',
    't_es_login_pf_manager': 'FR Log into your Energy Star Portfolio Manager',
    't_es_prompted_username': 'FR When prompted, enter “Evora_Siera” as the username.',
    't_es_add_contact_button': 'FR I have added Evora_Siera as a contact',
    't_es_requested_account_text': 'FR {0}\'s Energy Star Portfolio Manager account has requested to connect with your SIERA account.',
    't_es_account_id': 'FR Enter your ES Portfolio Manager account ID. You can find this in your ES Portfolio Manager account settings.',
    't_es_confirm_connection': 'FR Confirm connection',
    't_es_not_recognise_request': 'FR If you don\'t recognise this request, please select cancel.',
    't_es_account_sharing': 'FR Head back to your Energy Star Portfolio Manager account and go to {0}.',
    't_es_sharing': 'FR Sharing',
    't_es_select_share': 'FR Select \'share with your utility or service provider\' and share properties with SIERA.',
    't_es_set_props_full_access': 'FR Please ensure you are setting properties to full access.',
    't_es_i_have_set_up_sharing': 'FR I have set up sharing',
    't_es_available_assets': 'FR These are available Assets we found matches for in your Energy Star Portfolio Manager account. Please select the Assets you would like to extract ratings for and check that our suggested match is correct.\n',
    't_es_change_permission_and_support': 'FR If you do not see an Asset you would like to import data for, you may need to change permissions in your ES Portfolio Manager account or {0}. ',
    't_es_contact_support': 'FR Contact Support',
    't_es_confirm': 'FR Confirm',
    't_es_asset_in_siera': 'FR Asset in SIERA',
    't_es_asset_in_portfolio_manager': 'FR Respective Asset in ES Portfolio Manager',
    't_es_success': 'FR You can now view the Energy Star ratings for successfully matched Assets in SIERA.',
    't_success': 'FR Success',
    't_continue': 'FR Continue',
    't_action_based_pathway_stranding': 'FR Action-based pathway CRREM Misalignment in',
    't_fund_carbon_intensity': 'FR Fund carbon intensity',
    't_fund_energy_intensity': 'FR Fund energy intensity',
    't_es_step_three_error': 'Error: FR We couldn\'t find shared properties from your ES Porfolio Manager account.\n Please make sure you have set up sharing with full access.',
    't_es_step_two_error': 'Error: FR We couldn\'t find a request from the account ID you entered.\n Please check the ID is correct and try again.',
    't_es_step_one_error': 'Error: FR Please make sure you have added SIERA as a contact before proceeding.',
    't_es_api_error': 'Error: FR Contacting the Energy Star Portfolio Manager is not possible at the moment. Please try again later.\n If the error continues to happen, please contact support.',
    't_year_from_to_4_digits': 'FR Ensure year To is not less than year From (Please note 4 digits must be entered in these boxes)',
    't_min_max_numeric': 'FR Ensure maximum value is greater than minimum value (Numeric only)',
    't_es_matched_assets_info': 'FR These are the Assets in your SIERA account that have been matched with properties in your Energy Star Portfolio Manager. You can view Energy Star Ratings for these Assets in SIERA.',
    't_es_matched_assets_count': 'FR {0} of {1} Assets matched',
    't_es_sync_frequency': 'FR Sync frequency',
    't_es_match_more_assets': 'FR Match more Assets',
    't_address': 'FR Address',
    't_last_sync': 'FR Last Sync',
    't_jpeg_small': 'FR Small JPEG',
    't_png_small': 'FR Small PNG',
    't_jpeg_medium': 'FR Medium JPEG',
    't_png_medium': 'FR Medium PNG',
    't_jpeg_large': 'FR Large JPEG',
    't_png_large': 'FR Large PNG',
    't_max_length_30': 'FR Custom pathway maximum character length is 30 characters',
    't_unique_pathway_name': 'FR The custom pathway name must be unique',
    't_tp_name_validation': 'FR Name can only contain numbers & letters',
    't_monthly': 'FR Monthly',
    't_yearly': 'FR Yearly',
    't_mean_carbon_intensity': 'FR Mean carbon intensity',
    't_data_availability_assets': 'FR Data availability of assets',
    't_uplifted': 'FR Uplifted',
    't_benchmark': 'FR Benchmarked',
    't_target_pathway_2': 'FR Target Pathway 2',
    't_target_pathway_3': 'FR Target Pathway 3',
    't_unique_custom_target_pathway_name': 'FR Custom pathway name must be unique',
    't_tp_name_empty': 'FR Custom pathway name cannot be empty',
    't_example': 'FR E.g.',
    't_no_assets_to_match': 'FR No assets to match.',
    't_intensity': 'FR Intensity',
    't_portfolio_excel': 'FR SIERA Portfolio.xlsx',
    't_excel_tab_name': 'FR Assets Raw Data',
    't_client_name': 'FR Client',
    't_agent_name': 'FR Agent',
    't_purchase_date': 'FR Purchase date',
    't_sale_date': 'FR Sale date',
    't_property_status': 'FR Property Status',
    't_gresb_sector': 'FR GRESB sector',
    't_energy_star_sector': 'FR Energy Star sector',
    't_select_energy_star_sector': 'FR Select Energy Star sector',
    't_gresb_management_status': 'FR GRESB management status',
    't_gia_m_sqrt': 'FR GIA (m2)',
    't_nla_m_sqrt': 'FR NLA (m2)',
    't_cpa_m_sqrt': 'FR CPA (m2)',
    't_is_cpa_estimated': 'FR Is CPA estimated?',
    't_gas_expected': 'FR Gas expected',
    't_water_expected': 'FR Water expected',
    't_electricity_expected': 'FR Electricity expected',
    't_oil_expected': 'FR Oil expected',
    't_district_heating_expected': 'FR District heating expected',
    't_district_cooling_expected': 'FR District cooling expected',
    't_fund_performance_excel': 'FR SIERA Fund Performance.xlsx',
    't_view_nzc_tp_for_asset': 'FR View detailed NZC pathways for this asset',
    't_fund_carbon_performance_report': 'FR Fund Carbon Performance Report',
    't_fund_electricity_performance_report': 'FR Fund Electricity Performance Report',
    't_fund_thermals_performance_report': 'FR Fund Gas, Fuels & Thermals Performance Report',
    't_fund_waste_performance_report': 'FR Fund Waste Performance Report',
    't_fund_water_performance_report': 'FR Fund Water Performance Report',
    't_fund_level_summary': 'FR Fund Level Summary',
    't_total_consumption_excel': 'FR Total Consumption (MWh)',
    't_asset_level_total_consumption_excel': 'FR Total Consumption ({0})',
    't_total_emission_excel': 'FR Total Emissions ({0})',
    't_total_consumption': 'FR Total Consumption ({0})',
    't_total_carbon_emission_excel': 'FR Total Carbon Emission (T)',
    't_gap_filled_data_excel': 'FR Gap Filled Data (%)',
    't_over_under_target_excel': 'FR Over/Under target (%)',
    't_time_period_excel': 'FR Time Period',
    't_asset_information_excel': 'FR Asset Information',
    't_floor_area_excel': 'FR Floor Area (m2)',
    't_floor_area_excel_imperial': 'FR Floor Area (ft2)',
    't_occupancy_excel': 'FR Occupancy (%)',
    't_intensity_excel': 'FR Intensity ({0})',
    't_carbon_intensity_excel': 'FR Carbon intensity ({0})',
    't_recycled_waste_excel': 'FR Recycled Waste (t)',
    't_total_waste_excel': 'FR Total Waste (t)',
    't_recycled_percentage_excel': 'FR % Recycled',
    't_recycled_percentage_change_excel': 'FR % change in recycled waste',
    't_post_code': 'FR Post code',
    't_interim_target': 'FR Interim target',
    't_month_to_end_of': 'FR month to end of', // to be updated
    't_months_to_end_of': 'FR months to end of', // to be updated
    't_energy_intensity_excel': 'FR Energy Intensity (m3/m2)',
    't_title_update_target_pathway_failed': 'FR Update target pathway failed',
    't_title_delete_target_pathway_failed': 'FR Delete target pathway failed',
    't_ton_co2_yr': 'FR tCO₂e/yr',
    't_average_carbon_intensity': 'FR Average Carbon intensity',
    't_average_energy_intensity': 'FR Average Energy intensity',
    't_average_cost_intensity': 'FR Average Cost intensity',
    't_performance_assets_model': 'FR Performance for assets used in model',
    't_energy_intensity_nzc': 'FR Energy intensity',
    't_selected_utility_excel': 'FR {0} - EXCEL',
    't_all_utilities_excel': 'FR All utilities - EXCEL',
    't_gas_fuels_thermals': 'FR Gas, fuels and thermals',
    't_total_energy_consumption': 'FR Total energy consumption (MWH)',
    't_fund_performance_report': 'FR Fund Performance Report',
    't_energy_summary': 'FR Energy Summary',
    't_remove_match': 'FR Remove match',
    't_remove': 'FR Remove',
    't_action_by_impact_excel': 'FR Actions by impact - EXCEL',
    't_action_by_status_excel': 'FR Actions by status - EXCEL',
    't_es_reset_warning_message_one': 'FR Cancelling will take you back to Step 1.',
    't_es_reset_warning_message_two': 'FR Are you sure you want to cancel the integration {0} set up process?',
    't_es_reset_warning_header_message': 'FR Cancel integration set up process',
    't_es_reset_warning_yes': 'FR Yes, cancel',
    't_es_reset_warning_no': 'FR Stay on step 4',
    't_tenant_data_quality': 'FR Tenant data quality',
    't_landlord_data_quality': 'FR Landlord data quality',
    't_tenant_procured_assets': 'FR Tenant procured assets',
    't_landlord_procured_assets': 'FR Landlord procured assets',
    't_actual_percentage': 'FR Actual (%)',
    't_supplier_estimated_percentage': 'FR Supplier estimated (%)',
    't_incomplete_percentage': 'FR Incomplete (%)',
    't_not_covered_percentage': 'FR Not covered (%)',
    't_total_missing_percentage': 'FR Total missing (%)',
    't_managing_agent': 'FR Managing agent',
    't_portion_of_missing_fund_data_percentage': 'FR Portion of missing fund data (%)',
    't_dq_floor_area_landlord': 'FR Maximum landlord floor area ({0})',
    't_dq_floor_area_tenant': 'FR Maximum tenant floor area ({0})',
    't_dq_floor_area_without_data': 'FR Floor area for which you have no data ({0})',
    't_dq_floor_area': 'FR Floor area ({0})',
    't_fund_data_quality_excel': 'FR Fund Data Quality Excel',
    't_fund_data_quality_report': 'FR Fund Data Quality Report',
    't_upload_consumption_data': 'FR Upload consumption data',
    't_upload_action_plans': 'FR Upload action plans',
    't_action_plan_point_two': 'FR Upload actions data',
    't_consumption_upload_sub_text': 'FR Uploading consumption data will improve your data completeness scores and help you accurately track your sustainability goals. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to submit consumption data.',
    't_action_plan_sub_text': 'FR You can manage significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload consumption data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload/edit action plans in bulk.',
    't_consumption_upload_template_point_one': 'FR Download and populate your consumption template',
    't_action_plan_upload_template_point_one': 'FR Generate and populate your template',
    't_consumption_upload_point_one_subtext': 'FR Populate the template with your consumption data. The template has been partially populated to help you get the data in the right place.',
    't_action_plan_upload_point_one_subtext': 'FR Populate the template with your list of actions. The template has been partially populated to help you get the data in the right place.',
    't_download_template': 'FR Generate template',
    't_upload_template': 'FR Upload template',
    't_action_plan_upload_point_two_subtext': 'FR When you upload your completed template, you will be guided through an error handling process.',
    't_consumption_upload_success_title': 'FR Data upload successful',
    't_consumption_upload_success_text_one': 'FR Consumption has been uploaded for {0} meters. Uploaded on {1} by {2}.',
    't_consumption_upload_success_text_two': 'FR Your data will be available to view on the performance pages within 15 minutes. We\'ll send you an email when it\'s ready.',
    't_action_upload_success_text_one': 'FR {0} action plans have been uploaded. Uploaded on {1} by {2}',
    't_action_upload_success_text_two': 'FR Your data will be available to view on each asset\'s action plan page. We\'ll send you an email when its ready',
    't_action_upload_single_asset_success_text_one': 'FR Actions has been uploaded for {0}. Uploaded on {1} by {2}',
    't_consumption_upload_error_title': 'FR Data upload unsuccessful',
    't_consumption_upload_error_text_one': 'FR We\'re sorry, something\'s gone wrong.',
    't_consumption_upload_error_text_two': 'FR Your upload has been unsuccessful. Please {0} or try again.',
    't_return_home': 'FR Return home',
    't_return_action':'FR Return to Actions',
    't_upload_bulk_consumption': 'FR Bulk add consumption',
    't_upload_bulk_action_plan': 'FR Bulk add/edit actions',
    't_upload_bulk_consumption_assets_warning_button_back': 'FR OK, back',
    't_upload_bulk_consumption_assets_warning_button_agree': 'FR Upload anyway',
    't_upload_bulk_consumption_assets_warning': 'FR You\'re about to upload consumption data to a very large list of assets. We would recommend filtering your asset list to make your upload template more manageable.',
    't_fund_action_plan_report': 'FR Action Plan Report',
    't_total_agreed_actions': 'FR Total agreed actions',
    't_un_costed_actions': 'FR Un-costed actions',
    't_unit_of_measurement': 'FR Unit of measurement',
    't_overdue_actions': 'FR Overdue actions',
    't_under_review_actions': 'FR Actions under review',
    't_fund_agreed_actions_summary': 'FR Fund level summary of agreed actions',
    't_fund_overdue_actions_summary': 'FR Fund level summary of overdue actions',
    't_fund_completed_actions_summary': 'FR Fund level summary of completed actions',
    't_fund_applicable_actions_summary': 'FR Fund level summary of applicable actions',
    't_fund_under_review_actions_summary': 'FR Fund level summary of actions under review',
    't_fund_action_plan_status_excel': 'FR Fund ActionPlan (by status)',
    't_no_fund_actions_with_status': 'FR This fund has no actions with this status',
    't_actions_per_year': 'FR Actions per year',
    't_asset_performance_excel': 'FR Asset performance EXCEL',
    't_gas_fuels_performance': 'FR Gas, Fuels & Thermals performance report',
    't_water_performance': 'FR Water performance report',
    't_waste_performance': 'FR Waste performance report',
    't_carbon_performance': 'FR Carbon performance report',
    't_asset_performance_export': 'FR Asset performance export from portfolio view',
    't_asset_gas_fuels_thermals': 'FR Gas, fuels & thermals',
    't_total_energy_consumption_kwh': 'FR Total energy consumption (KWH or MWH)',
    't_gap_filled_energy_data': 'FR Gap-filled energy data (%)',
    't_current_energy_consumption': 'FR Current energy consumption (KWH)',
    't_generate_your_template': 'FR Generate your consumption template',
    't_generate_your_action_plan_template': 'FR Generate your action plan template',
    't_asset_details_excel': 'FR Asset details EXCEL',
    't_no_data_to_export': 'FR No data available to export',
    't_total_carbon_emissions': 'FR Total Carbon Emissions ({0})',
    't_landlord_summary': 'FR Landlord summary',
    't_tenant_summary': 'FR Tenant summary',
    't_dq_floor_area_gia': 'FR Floor area ({0}) GIA',
    't_fund_action_plan_impact_excel': 'FR Fund ActionPlan (by impact)',
    't_total_actions_for_category': 'FR Total actions in this category',
    't_fund_actions_bio_diversity_impact_summary': 'FR Fund level summary of actions with biodiversity impact',
    't_fund_actions_building_performance_impact_summary': 'FR Fund level summary of actions with building performance impact',
    't_fund_actions_community_engagement_impact_summary': 'FR Fund level summary of actions with community engagement impact',
    't_fund_actions_energy_impact_summary': 'FR Fund level summary of actions with energy impact',
    't_fund_actions_governance_recommended_impact_summary': 'FR Fund level summary of actions with governance recommended impact',
    't_fund_actions_health_wellbeing_impact_summary': 'FR Fund level summary of actions with health & wellbeing impact',
    't_fund_actions_social_value_impact_summary': 'FR Fund level summary of actions with social value impact',
    't_fund_actions_tenant_engagement_impact_summary': 'FR Fund level summary of actions with tenant engagement impact',
    't_fund_actions_waste_impact_summary': 'FR Fund level summary of actions with waste recycling impact',
    't_fund_actions_water_impact_summary': 'FR Fund level summary of actions with water impact',
    't_fund_actions_other_impact_summary': 'FR Fund level summary of actions with other impact',
    't_actions_with_bio_diversity_impact_title': 'FR Actions with biodiversity impact',
    't_actions_with_building_performance_impact_title': 'FR Actions with building performance impact',
    't_actions_with_community_engagement_impact_title': 'FR Actions with community engagement impact',
    't_actions_with_energy_impact_title': 'FR Actions with energy impact',
    't_actions_with_governance_recommended_impact_title': 'FR Actions with governance recommended impact',
    't_actions_with_health_wellbeing_impact_title': 'FR Actions with health & wellbeing impact',
    't_actions_with_social_value_impact_title': 'FR Actions with social value impact',
    't_actions_with_tenant_engagement_impact_title': 'FR Actions with tenant engagement impact',
    't_actions_with_waste_impact_title': 'FR Actions with waste recycling impact',
    't_actions_with_water_impact_title': 'FR Actions with water impact',
    't_actions_with_other_impact_title': 'FR Actions with other impact',
    't_fund_level_energy_summary': 'FR Fund level energy summary',
    't_asset_information': 'FR Asset information',
    't_total_floor_area_m2': 'FR Total Floor Area (m2)',
    't_tenant_controlled_asset': 'FR Tenant Controlled Asset',
    't_current_year_carbon_emissions_kg': 'FR Current Year Carbon Emissions (kg)',
    't_current_year_energy_consumption_kwh': 'FR Current Year Energy Consumption (KWH)',
    't_previous_year_carbon_emissions_kg': 'FR Previous Year Carbon Emissions (kg)',
    't_previous_annual_consumption_kwh': 'FR Previous annual consumption (KWH)',
    't_intensity_unit': 'FR Intensity ({0})',
    't_benchmark_kwh/m2': 'FR Benchmark (kWh/m2)',
    't_benchmark_m3/m2': 'FR Benchmark (m3/m2)',
    't_landfill_unit': 'FR Landfill ({0})',
    't_incinerated': 'FR Incinerated ({0})',
    't_recycled_unit': 'FR Recycled ({0})',
    't_reuse_unit': 'FR Reuse ({0})',
    't_anaerobic_t': 'FR Anaerobic (t)',
    't_hazardous_t': 'FR Hazardous (t)',
    't_unknown_unit': 'FR Unknown ({0})',
    't_total_t': 'FR Total (t)',
    't_energy_performance_report': 'FR Energy Performance Report',
    't_electricity_performance_report': 'FR Electricity Performance Report',
    't_gas_fuels_thermals_report': 'FR Gas, Fuels & Thermals Performance Report',
    't_water_performance_report': 'FR Water Performance Report',
    't_waste_performance_report': 'FR Waste Performance Report',
    't_carbon_performance_report': 'FR Carbon Performance Report',
    't_unsaved_changes': 'FR Unsaved changes',
    't_unsaved_changes_message': 'FR Do you want to save the changes to the model before navigating away?',
    't_leave_without_saving': 'FR Leave without saving',
    't_save_and_leave': 'FR Save and leave',
    't_support_guides': 'FR Support Guides',
    't_release_notes': 'FR Release Notes',
    't_asset_performance_report': 'FR Asset Performance Report',
    't_is_the_asset_tenant': 'FR Is the asset tenant controlled?',
    't_current_consumption': 'FR Current consumption',
    't_current_year_gap': 'FR Current year gap filled Data (%)',
    't_previous_annual_consumption': 'FR Previous annual consumption',
    't_previous_year_gap': 'FR Previous Year Gap Filled Data (%)',
    't_unit_of_measurement_for_consumption': 'FR Unit of measurement for consumption',
    't_benchmark_name': 'FR Benchmark',
    't_unit_of_measurement_for_intensity': 'FR Unit of measurement for intensity',
    't_kwh_m2': 'FR kWh/m2',
    't_m3': 'FR m3',
    't_m3_m2': 'FR m3/m2',
    't_kg_co2_m2': 'FR kg CO2e/m2',
    't_current_total_waste': 'FR Current Total Waste (t)',
    't_current_recycled_waste': 'FR Current Recycled Waste (t)',
    't_current_recycled': 'FR Current % Recycled',
    't_previous_total_waste': 'FR Previous Total Waste (t)',
    't_previous_recycled_waste': 'FR Previous Recycled Waste (t)',
    't_previous_recycled': 'FR Previous % Recycled',
    't_agreed_and_applicable_actions': 'FR Agreed and applicable actions',
    't_generate_template_user_text': 'FR The following will specify how your template is pre-populated.\nDon\'t worry, you\'ll still be able to edit the spreadsheet as you\nsee fit.',
    't_type_of_record': 'FR Type of record',
    't_template_to_generate': 'FR Template to generate',
    't_time_period': 'FR Time period',
    't_time_period_user_text': 'FR The template will only include date ranges for gaps in your consumption data, within your specified time period',
    't_meters_included_template': 'FR Meters included in template',
    't_file_name': 'FR File name',
    't_include_inactive_meters': 'FR Include inactive meters',
    't_generate': 'FR Generate',
    't_landlord_procured_meters': 'FR Landlord procured meters',
    't_tenant_procured_meters': 'FR Tenant procured meters',
    't_both': 'FR Both',
    't_asset_action_plans_excel': 'FR Asset action plans EXCEL',
    't_asset_data_quality_excel': 'FR Asset data quality EXCEL',
    't_benchmark_line': 'FR Benchmark line',
    't_no_benchmark': 'FR No Benchmark',
    't_benchmark_office_ac': 'FR BBP REEB Office A/C Typical Practice',
    't_benchmark_sc_ac': 'FR BBP REEB Enclosed SC A/C Typical Practice',
    't_consumption_upload': 'FR consumption upload',
    't_action_upload': 'FR action upload',
    't_bulk_consumption_instruction_header': 'FR SIERA Consumption Data Upload Template',
    't_bulk_action_plan_instruction_header': 'FR SIERA Actions Plan Add in Bulk Template',
    't_bulk_action_plan_edit_instruction_header': 'FR SIERA Actions Plan Edit in Bulk Template',
    't_bulk_consumption_instruction_note': 'FR Please note:',
    't_bulk_consumption_instruction_one': 'FR The submission of consumption data will contribute to your data quality and data completeness scores.',
    't_bulk_consumption_instruction_two': 'FR In order to upload consumption to SIERA, please populate sheet 2 of this spreadsheet (labelled \'consumption loader\') with your consumption figures. Then, upload the spreadsheet to SIERA on the same page you found this template.',
    't_bulk_consumption_instruction_three': 'FR We have pre-populated some of the columns for you, to help you populate the template from your internal records. Please feel free to change or add new date ranges according to the dates you have consumption records for, but please do not add any new columns and do not edit the meter ID column as we need exact ID\'s to add consumption to those meters.',
    't_bulk_consumption_instruction_four': 'FR Green headers indicate mandatory fields, whereas blue headers indicate optional fields.',
    't_bulk_consumption_instruction_six': 'FR We have only included meters in the template which we do not have a full set of consumption data for. If for whatever reason you need to override existing consumption records, please enter the exact date range for the consumption you want to override.',
    't_bulk_consumption_instruction_five': 'FR This template does not allow you to edit meter or asset characteristics. You will only be able to upload consumption data. To make any changes to asset or meter characteristics, please get in touch with an EVORA consultant or customer support.',
    't_bulk_consumption_instruction_seven': 'FR If the meter you are trying to upload consumption for is not listed on the template, you may not have access to upload consumption for this meter, or it may not exist on the system. Please get in touch with an EVORA consultant or our customer service team if you need to add a new meter before you upload consumption for that meter.',
    't_bulk_consumption_instruction_eight': 'FR If you require extra guidance on what a field means, you can click on the column and see a description of what the system requires for that field.',
    't_bulk_action_plan_instruction_one': 'FR This template will allow you to bulk Add Action Plans.',
    't_bulk_action_plan_edit_instruction_one': 'FR This template will allow you to bulk edit Action Plans.',
    't_bulk_action_plan_instruction_two': 'FR In order to add Actions in bulk, please go to sheet called "Bulk Add Template" under this file with all the relevant actions.',
    't_bulk_action_plan_edit_instruction_two': 'FR In order to edit Actions in bulk, please go to sheet called "Bulk Edit Template" under this file with all the relevant actions.',
    't_bulk_action_plan_instruction_three': 'FR Asset Reference Column has a list of all your assets within the fund, select the one you want the action to added to, if you downloaded the template from an Asset you will only get the individual asset.',
    't_bulk_action_plan_instruction_four': 'FR Each row represents an action, to add multiple to the same asset please select the same "Asset Reference in a new row"',
    't_bulk_action_plan_instruction_five': 'FR Columns highlighed in green are required, blue are optional.',
    't_bulk_action_plan_instruction_six': 'FR Once populated please reupload the filled in file back into SIERA.',
    't_bulk_action_plan_instruction_seven': 'FR If you require further guidance on each of the fields, click the header of the column for more information.',
    't_bulk_consumption_tooltip_asset_name': 'FR This is the name of the asset. Don’t see an asset or meter you need to add consumption for? Contact SIERA team to add it to the system.',
    't_bulk_consumption_tooltip_utility': 'FR The utility type this meter is associated with.',
    't_bulk_action_plan_edit_tooltip_actionId': 'FR DO NOT EDIT THIS',
    't_bulk_consumption_tooltip_area_covered': 'FR The area of the property which this meter covers.',
    't_bulk_consumption_tooltip_is_active': 'FR Is this meter active or inactive',
    't_bulk_consumption_tooltip_serial_number': 'FR The meter’s serial number',
    't_bulk_consumption_tooltip_meter_name': 'FR The meter name in SIERA. This should match up with your internal notes, so you can easily find which meter this refers to.',
    't_bulk_consumption_tooltip_from_date': 'FR The start date of this consumption record, in the format dd/mm/yyyy. We have populated the dates for which we do not have consumption data in the system, but feel free to replace these dates if you do not have data for the full date range.',
    't_bulk_consumption_tooltip_to_date': 'FR The end date of the consumption record, in the format dd/mm/yyyy',
    't_bulk_consumption_tooltip_origin': 'FR The origin of the consumption figure, eg. invoices or meter readings',
    't_bulk_consumption_tooltip_consumption': 'FR Please enter your consumption. We cannot accept meter readings at this time. Remove any commas or decimal places. Energy must be in kWh and water in m3.',
    't_bulk_consumption_tooltip_estimated': 'FR Is this consumption figure estimated or actual',
    't_bulk_action_plan_tooltip_assetReference': 'FR Select the asset you would like to add the action to, each row represents an action. So if you want to add multiple actions to the same asset please ensure you select it for each row.',
    't_bulk_action_plan_tooltip_gresbefficiency': 'FR Please ensure you select the GRESB Efficiency Measure if you have selected any of the following Impacts: Energy, Water and Waste.',
    't_bulk_action_plan_tooltip_cost': 'FR Please just enter the amount without currency characters.',
    't_bulk_action_plan_tooltip_currency': 'FR Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityType': 'FR Only applies to the following Impact Selections: Building Performance, Energy, Waste Recycling and Water',
    't_bulk_action_plan_tooltip_primaryUtilityChange': 'FR Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_bulk_action_plan_tooltip_primaryUtilityCostChange': 'FR Enter the amount of cost changes, currency dropdown applies to these fields, so only the amounts will be necessary.',
    't_bulk_action_plan_tooltip_secondaryUtilityChange': 'FR Please add the change in consumption. Add "-" before the number for a reduction or enter just the number for an increase in consumption',
    't_import_model_explanation_note_asset_name': 'FR You can only upload data related to {fundOrAssetName} asset',
    't_evoranzcdata': 'FR EvoraNZCData',
    't_summary': 'FR Summary',
    't_asset_performance_excel_file_name': 'FR SIERA Asset Performance Excel',
    't_total_energy_consumption_excel_mwh': 'FR Total Energy Consumption (MWh)',
    't_total_energy_consumption_excel_kwh': 'FR Total Energy Consumption (kWh)',
    't_action_export_from_portfolio_view': 'FR Actions export from portfolio view',
    't_summary_of_agreed_action': 'FR Summary of agreed actions',
    't_total_overdue_action': 'FR Total overdue actions',
    't_total_completed_action': 'FR Total completed actions',
    't_total_applicable_action': 'FR Total applicable actions',
    't_total_action_under_review': 'FR Total actions under review',
    't_action_estimated_savings': 'FR Estimated savings',
    't_action_area_covered': 'FR Area covered',
    't_summary_of_overdue_action': 'FR Summary of overdue actions',
    't_summary_of_completed_actions': 'FR Summary of completed actions',
    't_summary_of_applicable_actions': 'FR Summary of applicable actions',
    't_summary_of_actions_under_review': 'FR Summary of actions under review',
    't_no_assets_selected_actions_status': 'FR The assets selected have no actions with this status',
    't_missing_fund_data_weighted_by_floor_area': 'FR Missing fund data, weighted by floor area (%)',
    't_floor_area_for_no_data': 'FR Floor area not covered  ({0}) ',
    't_floor_area_not_covered_percentage': 'FR Floor area not covered (%)',
    't_portfolio_data_quality_report': 'FR Data Quality Report',
    't_portfolio_data_quality_file_name': 'FR Portfolio Data Quality Report',
    't_current_energy_consumption_kwh': 'FR Current Energy Consumption (kWh)',
    't_level_of_details_by_asset': 'FR By asset',
    't_level_of_details_by_meter': 'FR By meter',
    't_time_period_granularity_annual': 'FR Annual',
    't_time_period_granularity_monthly': 'FR Monthly',
    't_level_of_detail': 'FR Level of detail',
    't_time_period_granularity': 'FR Time period granularity',
    't_name_must_not_exceed_50_characters': 'FR The model name must not contain more than 50 characters',
    't_current_reporting_period_total_energy_consumption': 'FR Current Reporting Period Total Energy Consumption ({0})',
    't_current_reporting_gap_filled_energy_data_percentage': 'FR Current Reporting Gap-filled Energy Data (%)',
    't_previous_reporting_period_total_energy_consumption': 'FR Previous Reporting Period Total Energy Consumption ({0})',
    't_previous_reporting_gap_filled_energy_data_percentage': 'FR Previous Reporting Gap-filled Energy Data (%)',
    't_total_asset_floor_area': 'FR Total Asset Floor Area ({0})',
    't_reporting_period': 'FR Reporting Period',
    't_reporting_period_gap_filler_data_percentage': 'FR Reporting Period Gap Filled Data (%)',
    't_reporting_period_carbon_emissions': 'FR Reporting Period Carbon Emissions ({0})',
    't_current_reporting_period_total_consumption': 'FR Current Reporting Period Total Consumption ({0})',
    't_utility_meter_unavailable': 'FR Unavailable: no meter for',
    't_current_reporting_period_gap_filled_data_percentage': 'FR Current Reporting Period Gap Filled Data (%)',
    't_previous_reporting_period_total_consumption': 'FR Previous Reporting Period Total Consumption ({0})',
    't_previous_reporting_period_gap_filled_data_percentage': 'FR Previous Reporting Period Gap Filled Data (%)',
    't_current_reporting_period_total_waste': 'FR Current Reporting Period Total Waste ({0})',
    't_current_reporting_period_recycled_waste': 'FR Current Reporting Period Recycled Waste ({0})',
    't_current_percentage_recycled': 'FR Current % Recycled',
    't_previous_reporting_period_total_waste': 'FR Previous Reporting Period Total Waste ({0})',
    't_hazardous_waste': 'FR Hazardous Waste ({0})',
    't_non_hazardous_waste': 'FR Non-hazardous Waste ({0})',
    't_total_waste_generated': 'FR Total Waste Generated ({0})',
    't_waste_to_energy_unit': 'FR Waste to energy ({0})',
    't_waste_generated': 'FR Waste Generated',
    't_destination': 'FR Destination',
    't_current_reporting_period_total_emissions': 'FR Current Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_total_emissions': 'FR Previous Reporting Period Total Emissions ({0})',
    't_previous_reporting_period_recycled_waste': 'FR Previous Reporting Period Recycled Waste ({0})',
    't_emissions': 'FR Emissions',
    't_current_total_carbon_emissions': 'FR Current total Carbon Emissions ({0})',
    't_scope_1_emissions': 'FR Scope 1 emissions ({0})',
    't_scope_2_emissions': 'FR Scope 2 emissions ({0})',
    't_scope_3_emissions': 'FR Scope 3 emissions ({0})',
    't_current_period_consumption_with_gapFilled_data': 'FR Current period consumption ({0})',
    't_current_period_gapFilled_data': 'FR Current period Gap Filled Data (%)',
    't_previous_period_consumption_with_gapFilled_data': 'FR Previous period consumption ({0})',
    't_previous_period_gapFilled_data': 'FR Previous period Gap Filled Data (%)',
    't_previous_period_total_carbon_emissions': 'FR Previous period\'s total carbon emissions ({0})',
    't_current_consumption_with_gapFilled_data': 'FR Current period consumption ({0})',
    't_current_energy_consumption_with_gapFilled_data': 'FR Current energy consumption ({0})',
    't_previous_energy_consumption_kwh_with_gapFilled_data': 'FR Previous energy consumption ({0})',
    't_import_file_error_message': 'FR The import file name must not contain more than 50 characters',
    't_no_export_data_available': 'FR The assets selected have no data available for this utility within the specified time frame.',
    't_current_reporting_period_gap_filled_energy_data_percentage': 'FR Current Reporting Period Gap-Filled Energy Data (%)',
    't_previous_reporting_period_gap_filled_energy_data_percentage': 'FR Previous Reporting Period Gap-Filled Energy Data (%)',
    't_meter_name': 'FR Meter name',
    't_serial_number': 'FR Serial number',
    't_comment': 'FR Comment',
    't_active_from': 'FR Active from',
    't_active_to': 'FR Active to',
    't_is_this_a_submeter': 'FR Is this a submeter?',
    't_floor_area_served_by_meter': 'FR Floor area served by Meter ({0})',
    't_green_tariff': 'FR Green tariff',
    't_current_annual_consumption_includes_gap_filled_data': 'FR Current annual consumption ({0}) (includes gap-filled data)',
    't_previous_year_total_consumption_includes_gap_filled_data': 'FR Previous year\'s total consumption ({0}) (includes gap-filled data)',
    't_floor_area_served': 'FR Floor area served ({0})',
    't_previous_periods_total_consumption_includes_gap_filled_data': 'FR Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_waste_disposal_route_reference': 'FR Waste disposal route reference',
    't_contractor': 'FR Contractor',
    't_waste_type': 'FR Waste Type',
    't_previous_period_carbon_emissions': 'FR Previous period carbon emissions ({0})',
    't_previous_periods_total_consumption_include_gap_filled_data': 'FR Previous period\'s total consumption ({0}) (includes gap-filled data)',
    't_meter_information': 'FR Meter Information',
    't_actions_date': 'FR Based on {0}',
    't_water_intensity_excel': 'FR Water Intensity ({0})',
    't_export_data_quality_excel': 'FR Export data quality - EXCEL',
    't_current_consumption_with_excluding_gapFilled_data': 'FR Current consumption ({0}) (excluding gap-filled data)',
    't_previous_consumption_with_excluding_gapFilled_data': 'FR Previous period consumption ({0}) (excluding gap-filled data)',
    't_current_energy_consumption_with_excluding_gapFilled_data': 'FR Current energy consumption ({0}) (excluding gap-filled data)',
    't_previous_energy_consumption_kwh_with_excluding_gapFilled_data': 'FR Previous energy consumption ({0}) (excluding gap-filled data)',
    't_manage_es_integration_link': 'FR Manage Energy Star integration',
    't_assets_info_with_no_agreed_actions': 'FR In the current NZC model, {0} out of {1} assets have no agreed energy-saving actions.',
    't_assets_info_with_agreed_actions': 'FR In current NZC model, all {0} assets have at least one energy-saving action defined.',
    't_data_below_target': 'FR Data below target',
    't_gap_filled_data_below_target': 'FR Gap-filled data below target',
    't_data_above_target': 'FR Data above target',
    't_gap_filled_data_above_target_updated': 'FR Gap-filled data above target',
    't_data_below_previous_period': 'FR Data below previous period',
    't_gap_filled_data_below_previous_period': 'FR Gap-filled data below previous period',
    't_data_above_previous_period': 'FR Data above previous period',
    't_gap_filled_data_above_previous_period': 'FR Gap-filled data above previous period',
    't_carbon_scope_info': '<p><b>FR Scope 1: </b>Carbon emissions from landlord gas and oil</p> <p><b>Scope 2: </b>Carbon emissions from landlord electricity, district heating and district cooling</p> <p><b>Scope 3: </b>Carbon emissions from tenant energy usage</p> ',
    't_data_quality_info': 'FR Reports can be compiled with any level of Data Quality using gap-filling, but this will affect the accuracy of your outputs. We recommend using the Data Quality page to increase the completeness of your data.',
    't_industry_standard_benchmark': 'FR Industry standard benchmark ({0})',
    't_variance_against_industry_standard_benchmark': 'FR Variance against Industry Standard Benchmark (%)',
    't_asset_nzc_action_based_target_pathway_info': 'FR Action-based pathways aggregate all of the energy-saving actions that have been defined in the current model and present them as a single pathway.',
    't_asset_nzc_custom_based_target_pathway_info': 'FR Custom target pathways allow you to specify your own targets over time for this asset in your model.',
    't_kwh_m2_yr': 'FR kWh/m²/yr',
    't_assets_with_scores': 'FR Assets with scores',
    't_gav_coverage': 'FR GAV coverage',
    't_date_completed': 'FR Date completed',
    't_total_emissions': 'FR Total Emissions',
    't_scope1_emissions': 'FR Scope 1 Emissions',
    't_scope2_emissions': 'FR Scope 2 Emissions',
    't_scope3_emissions': 'FR Scope 3 Emissions',
    't_missing_fund_data_weighted': 'FR Missing fund data, weighted by floor area (%)',
    't_commercial': 'FR Commercial',
    't_no_data_for_comparison': 'FR No data for comparison',
    't_landlord_tenant_split': 'FR Landlord/Tenant split',
    't_scope_breakdown': 'FR Scope breakdown',
    't_scope1_landlord': 'FR Scope 1 (Landlord)',
    't_scope2_landlord': 'FR Scope 2 (Landlord)',
    't_scope3_tenant': 'FR Scope 3 (Tenant)',
    't_scope1': 'FR Scope 1',
    't_scope2': 'FR Scope 2',
    't_scope3': 'FR Scope 3',
    't_net_change': 'FR Net change',
    't_required_asset_ref': 'FR Asset Reference *',
    't_impact_type': 'FR Impact (Type) *',
    't_gresb_efficiency_measure': 'FR GRESB Efficiency Measure',
    't_required_status': 'FR Status *',
    't_action_plan_title': 'FR Action Plan Title * (Max 50 Characters)',
    't_required_area_covered': 'FR Area Covered *',
    't_required_currency': 'FR Currency * \r\n(Required if applicable)',
    't_required_primary_utility_type': 'FR Primary Utility Type * \r\n(Required if applicable)',
    't_required_primary_utility_change': 'FR Primary Utility Change * \r\n(Required if applicable)',
    't_required_primary_utility_cost_change': 'FR Primary Utility Cost Change * \r\n(Required if applicable)',
    't_secondary_utility_type': 'FR Secondary Utility Type',
    't_secondary_utility_change': 'FR Secondary Utility Change',
    't_required_action_id': 'FR Action ID * \r\nDO NOT EDIT',
    't_active_inactive': 'FR Active / inactive',
    't_required_meter_pan': 'FR Meter name  / MPAN *',
    't_required_meter_id': 'FR Meter ID *',
    't_required_from_date': 'FR From date *',
    't_required_to_date': 'FR To date *',
    't_required_consumption': 'FR Consumption (Energy in kWh, Water in m3) *',
    't_required_estimate_actual': 'FR Estimated/actual *',
    't_required_origin': 'FR Origin *',
    't_scheduled_date': 'FR Scheduled date',
    't_estimated_change': 'FR Estimated change',
    't_find_action': 'FR Find action',
    't_filters': 'FR Filters',
    't_btn_request_consumption': 'FR Request consumption',
    't_header_request_consumption': 'FR Request Consumption',
    't_additional_information': 'FR Additional Information',
    't_serial_number_consumption': 'FR Serial Number',
    't_utility_type_consumption': 'FR Utility Type',
    't_area_covered_consumption': 'FR Area Covered',
    't_meter_status': 'FR Meter Status',
    't_submeter': 'FR Submeter',
    't_all_categories': 'FR All categories',
    't_estimated_data': 'FR Estimated data',
    't_delete_record': 'FR Delete record',
    't_delete_records': 'FR Delete records',
    't_edit_record': 'FR Edit record',
    't_edit_records': 'FR Edit records',
    't_add_consumptions': 'FR Add consumption',
    't_asset_procurement_data_categories': 'FR <p><b>Actual:</b> Consumption data entered for a meter.</p> <p><b>Estimated:</b> meter data derived from supplier estimates (e.g. from invoices).</p> <p><b>Incomplete:</b> where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p> <p><b>Not covered:</b> where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p> <p><b>Missing:</b> the combination of \'Incomplete\' and \'Not covered\'.</p>',
    't_request_email_label': 'FR Recipients (separate emails with commas)',
    't_request_email_placeholder': 'FR Add email recipients',
    't_request_send_button': 'FR Send request email',
    't_email_sent_confirmation': 'FR Email sent',
    't_select_utility': 'FR Select Utility',
    't_utilities': 'FR Utilities',
    't_clear_all': 'FR Clear all',
    't_select_status': 'FR Select status',
    't_select_impact': 'FR Select impact',
    't_select_cost_type': 'FR Select cost type',
    't_select_scope': 'FR Select scope',
    't_select_procurement': 'FR Select procurement',
    't_search_meter_placeholder': 'FR Search meter name...',
    't_no_meter_data_available': 'FR This meter has no data available within the specified time frame',
    't_select_all': 'FR Select All',
    't_error_title': 'FR Error',
    't_delete_warn': 'FR Are you sure you want to delete this record?',
    't_delete_warn_s': 'FR Are you sure you want to delete these records?',
    't_delete_yes': 'FR Yes, delete',
    't_cancel_delete': 'FR No, cancel',
    't_no_export_data_available_for_single_asset': 'FR The asset selected have no data available for this utility within the specified time frame.',
    't_origin': 'FR Origin',
    't_submitted_by': 'FR Submitted by',
    't_gap_filled_scope': 'FR gap-filled',
    't_procured_data': 'FR procured data',
    't_meter_submitted_by': 'FR Submitted By',
    't_action_plan_improvement_sub_text': 'FR Recording action plans enables you to track improvement opportunities at your assets. You can manage a significant amount of data simultaneously by uploading or editing action plans in bulk. In order to upload action plans to SIERA, the data needs to be in accordance with our data template.',
    't_nzc_available_not_siera': 'FR Net Zero Carbon module not available.',
    't_action_details': 'FR Action details',
    't_action_details_description': 'FR Key information associated with actions regarding how the Impact influences GRESB efficiency measures with Area coverage',
    't_estimated_actual_required': 'FR Estimated or Actual *',
    't_action_information': 'FR Action information',
    't_action_title': 'FR Action title',
    't_action_impact_error_message': 'FR Please select a impact',
    't_action_title_error_message': 'FR Please select a title',
    't_action_status_error_message': 'FR Please select a status',
    't_current_consumption_with_gapFilled': 'FR Current consumption ({0})',
    't_previous_consumption_with_gapFilled_data': 'FR Previous period consumption ({0})',
    't_consumption_information': 'FR Consumption Information',
    't_add_consumption_title': 'FR Add Consumption',
    't_edit_record_title': 'FR Edit Record',
    't_edit_records_title': 'FR Edit Records',
    't_update_record': 'FR Update Record',
    't_update_records': 'FR Update Records',
    't_update_record_confirmation': 'FR Record updated',
    't_update_records_confirmation': 'FR Records updated',
    't_submit_consumption': 'FR Submit consumption',
    't_submit_confirmation': 'FR Consumption added',
    't_associated_costs_utility': 'FR Associated costs and Utility',
    't_associated_costs_utility_desc': 'FR The savings per utility type and its cost. Negative value shows greater savings reduction and a positive value shows an increase',
    't_cost_of_action': 'FR Cost of action',
    't_select_currency': 'FR Select currency',
    't_action_currency_error_message': 'FR Please select a currency',
    't_action_title_error_msg': 'FR Please add a title',
    't_nodata_for_timeperiod': 'FR There is no data available for this time period',
    't_back_to_list': 'FR Back to List',
    't_add_data': 'FR Add Data',
    't_edit_data': 'FR Edit Data',
    't_select_area_covered': 'FR Select area covered',
    't_action_area_covered_error_message': 'FR Please select the area covered',
    't_gresb_efficiency_measure_select': 'FR Select GRESB efficiency measure',
    't_gresb_efficiency_measure_error_msg': 'FR Please select a GRESB efficiency measure',
    't_cooling_tower_drip': 'FR Cooling tower Drip / Smart irrigation',
    't_onsite_waste_water_treatment_reuse_of_storm_water': 'FR On-site waste water treatment / Reuse of storm water / Grey water',
    't_building_specific_communication': 'FR Building specific communication (i.e. posters, emails or newsletters)',
    't_feedback_sessions_individual_tenants': 'FR Feedback sessions with individual tenants - e.g. discussing sustainability requirements',
    't_social_media_online_platform': 'FR Social media / Online platform',
    't_tenant_meetings_which_includes': 'FR Tenant meetings which includes sustainability',
    't_tenant_sustainability_events': 'FR Tenant sustainability events',
    't_tenant_sustainability_guide': 'FR Tenant sustainability guide',
    't_tenant_sustainability_training': 'FR Tenant sustainability training',
    't_Tenants_feedback_energy_water_waste': 'FR Tenants receive feedback on energy, water or waste performance',
    't_gap_filled_split': 'FR Gap-filled',
    't_action_scheduled_completion_date': 'FR Scheduled completion date',
    't_action_completion_date': 'FR Completion date',
    't_select_primary_utility': 'FR Select primary utility',
    't_select_secondary_utility': 'FR Select secondary utility',
    't_primary_utility': 'FR Primary utility',
    't_secondary_utility': 'FR Secondary utility',
    't_primary_utility_error_message': 'FR Please select a primary utility',
    't_primary_utility_cost_error_msg': 'FR Please enter a change',
    't_choose_breakdown': 'FR Choose breakdown',
    't_modified_date': 'FR Modified date',
    't_gap_filling': 'FR Gap-filling',
    't_sold_badge_label': 'FR Sold in',
    't_view_detailed_dq_break_down': 'FR View detailed Data Quality breakdown',
    't_gresb_not_mandatory': 'FR GRESB efficiency measure selection is not mandatory but recommended',
    't_required_asset_name': 'FR Asset Name *',
    't_purchased': 'FR Purchased',
    't_nzc_sold': 'FR Sold',
    't_edit_asset': 'FR Edit asset',
    't_back_action_plan': 'FR Back to Action Plan',
    't_key_metrics': 'FR Key Metrics',
    't_payback_period': 'FR Payback period',
    't_matched_assets_count': 'FR {0} assets selected, please match the remaining assets',
    't_search_by_asset': 'FR Search by asset name',
    't_select_available_match': 'FR Select from {0} available matches',
    't_fund_sfdr_pai_report': 'FR SFDR PAI Report',
    't_y_o_y_trend': 'FR Year-on-Year Trend',
    't_adverse_sustainability_impact': 'FR Adverse Sustainability Impact',
    't_tonnes_co2e': 'FR tonnes CO2e',
    't_ghg_scope1': 'FR Scope 1 GHG emissions generated by real estate assets',
    't_ghg_scope2': 'FR Scope 2 GHG emissions generated by real estate assets',
    't_ghg_scope3': 'FR Scope 3 GHG emissions generated by real estate assets',
    't_ghg_scope_total': 'FR Total GHG emissions generated by real estate assets',
    't_including_estimates': 'FR Including estimates',
    't_actual_only': 'FR Actual Only',
    't_percentage': 'FR Percentage',
    't_vertical': 'FR Vertical',
    't_horizontal': 'FR Horizontal',
    't_fossil_fuels': 'FR Fossil Fuels',
    't_adverse_impact_ghg_emissions_by_scope': 'FR GHG emissions by scope',
    't_gia_tooltip_content': 'FR This is the total internal floor area associated with the asset and should equal the NLA and CPA.',
    't_nla_tooltip_content': 'FR This is the floor area associated with the lettable space only ( e.g. office or retail space) and excludes communal areas.',
    't_cpa_tooltip_content': 'FR This is the area associated with communal spaces such as reception areas, lift lobbies, stairwells and shared toilets.',
    't_ext_tooltip_content': 'FR This is the area associated with external areas such as car parks.',
    't_effect_on_utilities': 'FR Effect on utilities',
    't_single_year': 'FR year',
    't_multiple_years': 'FR years',
    't_gia_nla_required_message': 'FR Please ensure at least one field (GIA or NLA) is filled in',
    't_gia_nla_cpa_ext_length_validation_message': 'FR Amount entered is low. Please verify before continuing',
    't_gia_nla_cpa_adding error': 'FR Please ensure the values for the NLA and CPA equal the GIA',
    't_date_required': 'FR Please enter a date',
    't_future_year_error':'FR The year built can not be in the future',
    't_past_year_error' :'FR Year Built should be greater than 1800',
    't_invalid_year_error':'FR Invalid year format. Please enter a valid year',
    't_future_date_error': 'FR Date cannot be in the future',
    't_sale_date_error': 'FR Sale date must be after the purchase date',
    't_sale_date_before_purchase_date_error': 'FR Please enter the purchase date',
    't_post_note': 'FR Post a note',
    't_clear_note': 'FR Clear note',
    't_higher_than_target': 'FR higher than target',
    't_lower_than_target': 'FR lower than target',
    't_higher_than_previous_period': 'FR higher than previous period',
    't_lower_than_previous_period': 'FR lower than previous period',
    't_date_created': 'FR Date created',
    't_created_by': 'FR Created by',
    't_gresb_sector_tooltip': 'FR Select the sub type that best represents your asset , as per the  GRESB standard.',
    't_energy_star_sector_tooltip': 'FR Select the relevant sector from Energy Star categories that best describes your asset\'s industry for energy performance tracking and benchmarking.',
    't_operation_control_landlord_controlled_tooltip': 'FR {dynamic}: The Landlord has complete or partial ability to change operating policies, environmental policies and the purchase of utilities.',
    't_operation_control_tenant_controlled_tooltip': 'FR {dynamic}: Only the Tenant(s) have control over operating policies, environmental policies and the purchase of utilities.',
    't_please_select_option_from_dropdown': 'FR Please select an option from the dropdown',
    't_sync_success_message': 'FR Sync complete',
    't_notes_in_actions_not_saved': 'FR Do you want to save the changes to the action before navigating away?',
    't_select_the_country_of_asset': 'FR Select the country of the asset',
    't_select_the_region_of_asset': 'FR Select the region of the asset',
    't_enter_asset_name': 'FR Please Enter Asset Name',
    't_validation_asset_name': 'FR Asset name already exists. Choose a different name',
    't_validation_asset_reference': 'FR Asset reference already exists. Choose a different reference',
    't_enter_asset_reference': 'FR Please Enter Asset Reference',
    't_select_assetdetails_fund': 'FR Select a fund',
    't_asset_ownership_invalid_input': 'FR Invalid input. Please enter a numeric percentage value',
    't_asset_ownership_required': 'FR Please enter a Fund Ownership %',
    't_asset_ownership_min_value': 'FR Range should be between 1-100',
    't_asset_ownership_max_value': 'FR Range should be between 1-100',
    't_documents': 'FR Documents',
    't_pai_selection': 'FR PAI selection',
    't_real_estate_mandatory': 'FR Mandatory for Real Estate',
    't_select_at_least': 'FR Select at least one from below',
    't_operational_control_asset': 'FR Select the Operational Control for the asset',
    't_select_at_least_one_option': 'FR Please select at least one option from the dropdown',
    't_warning_gas_district_heating': 'FR Gas and district heating selected. Is this correct?',
    't_warning_gas_district_cooling': 'FR Gas and district cooling selected. Is this correct?',
    't_warning_gas_district_heating_and_district_cooling': 'FR Gas and district heating/district cooling selected. Is this correct?',
    't_enter_date_of_evaluation': 'FR Enter the date of this last evaluation',
    't_keyfacts': 'FR Key Facts',
    't_performance_overview': 'FR Performance overview',
    't_variance_against_target': 'FR Variance against target',
    't_variance_against_previous_period': 'FR Variance against previous period',
    't_below': 'FR below',
    't_above': 'FR above',
    't_gap_filled_data_not_applicable': 'FR gap-filled data not applicable',
    't_documents_n_certificates': 'FR Documents & Certificates',
    't_consumption_evidence': 'FR Consumption Evidence',
    't_filter_applied': 'FR {0} filter applied.',
    't_filters_applied': 'FR {0} filters applied.',
    't_download_documents': 'FR Download documents',
    't_top_down_pathways': 'FR Top-Down pathways',
    't_upload_top_down_pathways': 'FR Upload top-down pathways',
    't_pai_report': 'FR PAI Report',
    't_fossil_fuel_impact_report': 'FR Fossil Fuel Exposure Impact Report',
    't_energy_efficiency_impact_report': 'FR Energy Efficiency Impact Report',
    't_ghg_impact_report': 'FR GHG Emissions Impact Report',
    't_energy_consumption_impact_report': 'FR Energy Consumption Impact Report',
    't_waste_impact_report': 'FR Waste Management Impact Report',
    't_resource_consumption_impact_report': 'FR Resource Consumption Impact Report',
    't_biodiversity_impact_report': 'FR Biodiversity Impact Report',
    't_quarterly_summary': 'FR Quarterly Summary',
    't_exposed_value': 'FR Exposed Value',
    't_total_applicable_value': 'FR Total Applicable Value',
    't_total_excluded_value': 'FR Total Excluded Value',
    't_share_applicable_value_exposed': 'FR Share of applicable value exposed',
    't_share_total_value_excluded': 'FR Share of total value excluded',
    't_principle_metrics': 'FR Principle Metrics',
    't_average_share_exposed_value': 'FR Average share of exposed value',
    't_average_share_total_value_excluded': 'FR Average share of total value excluded',
    't_ped_below_nzeb': 'FR PED below NZEB?',
    't_total_portfolio_value': 'FR Total Portfolio Value',
    't_construction_year': 'FR Construction Year',
    't_total_scope1_emissions': 'FR Total Scope 1 Emissions',
    't_total_scope2_emissions': 'FR Total Scope 2 Emissions',
    't_total_scope3_emissions': 'FR Total Scope 3 Emissions',
    't_total_ghg_emissions': 'FR Total GHG Emissions',
    't_actual_data_only': 'FR Actual data only',
    't_including_estimations': 'FR Including estimations',
    't_exposed_value_share': 'FR Share of exposed value',
    't_inefficient_re': 'FR Inefficient RE',
    't_overview': 'FR Overview',
    't_ghg': 'FR GHG',
    't_ghg_emissions': 'FR GHG Emissions',
    't_total_contributing_area': 'FR Total contributing area',
    't_total_raw_material_usage': 'FR Total Raw Material Usage',
    't_sustainable_raw_material_usage': 'FR Sustainable Raw Material Usage',
    't_sustainable_raw_material_usage_share': 'FR Share of Sustainable Raw Material Usage',
    't_horizontal_artificialization': 'FR Horizontal Artificialisation',
    't_vertical_artificialization': 'FR Vertical Artificialisation',
    't_coverage_by_floorArea': 'FR Coverage by floor area',
    't_filename': 'FR File Name',
    't_document_type': 'FR Document Type',
    't_implementation_date': 'FR Implementation Date',
    't_date_of_upload': 'FR Date of Upload',
    't_uploaded_by': 'FR Uploaded by',
    't_fundname': 'FR Fund Name',
    't_document_size': 'FR Document Size',
    't_export_documents': 'FR Export documents',
    't_validation_errors': 'FR Record has validation errors',
    't_validation_warning': 'FR Record has warnings',
    't_validation_consumption_blank': 'FR Please enter consumption for this date range.',
    't_validation_consumption_specific': 'FR Please specify whether this consumption is estimated or actual.',
    't_validation_source': 'FR Please specify the origin of the consumption figure, for example invoice or meter reading.',
    't_validation_from_date_blank': 'FR Please enter from date.',
    't_validation_to_date_blank': 'FR Please enter to date.',
    't_validation_comment': 'FR This is now a required field, because you calculated an estimate for this consumption figure. Please explain the methodology behind your calculation.',
    't_validation_negative_not_allowed': 'FR SIERA cannot accept negative values. Please get in touch with our support team or adjust your consumption by pro-rating. {0}.',
    't_warning_consumption_inactive': 'FR You are submitting consumption for a meter that is tagged as inactive during this time period. Please check your dates are correct, and check the meter status is up to date.',
    't_warning_consumption_same_period': 'FR This consumption figure is +-10% for the same period in the previous year. Please check you have entered it correctly before proceeding, including decimal places and unit of measurement.',
    't_warning_consumption_same_diff_period': 'FR The exact consumption figure has been uploaded to a different meter before. Please check it is correct before proceeding.',
    't_validation_from_date_before_today': 'FR As you are submitting actual (not estimated) consumption, please select a date before today.',
    't_validation_from_date_lesser': 'FR From date should be less than or equal to To date.',
    't_validation_date_overlap': 'FR We already have consumption data for {0}. Please adjust your data to a new date range to avoid overlaps. {1}.',
    't_upload_nzc_top_down_pathways': 'FR Upload NZC Top-Down Pathway',
    't_upload_nzc_top_down_pathways_subtext': 'FR You can import up to 7 NZC Top-Down pathways simultaneously. In order to upload the pathway data to SIERA, the data needs to be in accordance with our data template. {0} about how to upload NZC Top-Down Pathways into Siera.',
    't_upload_nzc_top_down_pathways_point_one': 'FR Generate and populate your template',
    't_upload_nzc_top_down_pathways_point_one_subtext': 'FR Populate the template with your list of Pathways. The template has been partially populated to help you get the data in the right place.',
    't_upload_nzc_top_down_pathways_point_two': 'FR Upload NZC Top-Down pathways data',
    't_upload_nzc_top_down_pathways_point_two_subtext': 'FR When you upload your completed template, you will be guided through an error handling process.',
    't_actions_breakdown': 'FR Actions breakdown',
    't_filenames': 'FR File Name(s)',
    't_metername': 'FR Meter Name',
    't_select_the_status_of_asset': 'FR Please select a status for this asset.',
    't_to_tc': 'FR To',
    't_delete_document': 'FR Delete document',
    't_confirm_delete_document': 'FR Are you sure you want to delete this document?',
    't_confirm_delete_documents': 'FR Are you sure you want to delete these documents?',
    't_top_down_carbon_intensity': 'FR Top-Down Carbon intensity',
    't_top_down_energy_intensity': 'FR Top-Down Energy intensity',
    't_top_down_pathways_template_filename': 'FR Upload_NZC_TopDown_Pathways_Template',
    't_top_down_pathways_carbon_template_title': 'FR Uploading NZC Top Down Pathways - Carbon Intensity',
    't_top_down_pathways_energy_template_title': 'FR Uploading NZC Top Down Pathways - Energy Intensity',
    't_how_to_use_this_template': 'FR How to use this template',
    't_pathway_name': 'FR Pathway Name',
    't_pathway':'FR Pathway',
    't_top_down_template_instruction_1': 'FR This excel sheet is used to upload Top Down Pathways.',
    't_top_down_template_instruction_2': 'FR This sheet has rows where you enter the Pathway names - these are editable with a max character limit of 40.',
    't_top_down_template_instruction_3': 'FR You can only upload upto a maximum of 7 pathways (rows).',
    't_top_down_template_instruction_4': 'FR The columns indicate the Years, these are pre-selected from 2019-2050.',
    't_top_down_template_instruction_5': 'FR You can choose to enter in any cells under the year column (can also leave them blank).',
    't_top_down_template_instruction_6': 'FR You must enter numerical values in these cells.',
    't_top_down_template_instruction_7': 'FR Please make sure you know the units you are using from Siera.',
    't_previous_period_recycled': 'FR previous period (recycled)',
    't_sustainable_weight_greater_than_total_weight': 'Sustainable materials weight cannot be greater than the total weight',
    't_start_date_before_end_date': 'FR Start date must be before end date',
    't_total_missing_data': 'FR total missing data',
    't_filter_documents': 'FR Filter documents',
    't_filter_consumption_evidence': 'FR Filter consumption evidence',
    't_valid_within': 'FR Valid within',
    't_evidence_date_range': 'FR Evidence date range',
    't_pick_date_range': 'FR Pick a date range',
    't_pick_evidence_date_range': 'FR Pick evidence date range',
    't_doc_type': 'FR Document type',
    't_select_doc_type': 'FR Select document type',
    't_select_doc_fund': 'FR Select fund',
    't_select_asset': 'FR Select asset',
    't_select_doc_country': 'FR Select country',
    't_select_managing_agent': 'FR Select managing agent',
    't_select_user': 'FR Select user',
    't_search_fund': 'FR Search by fund name',
    't_search_asset': 'FR Search by asset name or asset ref',
    't_search_name': 'FR Search by name',
    't_search_document': 'FR Search by document name',
    't_search_country': 'FR Search by country name',
    't_select_meter': 'FR Select meter',
    't_search_meter': 'FR Search meter',
    't_search_sector': 'FR Search sector',
    't_assurance_doc': 'FR Assurance document',
    't_audit_report': 'FR Audit/Recommendations report',
    't_energy_rating_certificate': 'FR Energy rating certificate',
    't_fund_report': 'FR Fund reports',
    't_green_building_certificate': 'FR Green building certificate',
    't_sustainability_action_plan': 'FR Sustainability action plan',
    't_select_a_status': 'FR Select a status',
    't_remove_item': 'FR Remove item',
    't_add_new_record': 'FR Add new record',
    't_add_old_record': 'FR Add old record',
    't_select_date_error': 'FR Please select a date',
    't_date_set_automatically': 'FR This date is set automatically by the above item\'s Start date. This is to make sure there\'s no gaps or overlaps between items on the timeline.',
    't_present': 'FR Present',
    't_exposed': 'FR Exposed',
    't_not_exposed': 'FR Not exposed',
    't_renewable_energy_certificate':'FR Renewable energy certificate',
    't_expiry_date':'FR Expiry date',
    't_select_expiry_date':'FR Select expiry date',
    't_report_date':'FR Report date *',
    't_select_report_date':'FR Select a valid report date',
    't_record_type_document':'FR Which record type does this document belong to? *',
    't_select_record_type':'FR Select record type',
    't_select_document_type':'FR Select document type',
    't_drag_drop':'FR Drag and drop or',
    't_document_select_file':'FR Select file',
    't_document_export':'FR Document Export',
    't_add_document':'FR Add document',
    't_search_fund_ref':'FR Search by fund name',
    't_delete_top_down_pathway': 'FR Delete top-down pathway',
    't_delete_topdownpathway_confirm_text': 'FR Are you sure you want to delete this top-down pathway?',
    't_exposure':'FR Exposure',
    't_contract_status': 'FR Contract status',
    't_active': 'FR Active',
    't_inactive': 'FR Inactive',
    't_saved':'FR Saved',
    't_document_upload':'FR Document upload *',
    't_asset_reference_address': 'FR Asset Reference & Address',
    't_clear_filters':'FR Clear filters',
    't_variance_previous_period_or_target':'FR Variance from previous period or target',
    't_reports_assetplanningpermissiondate_not_found_msg': 'FR Planning Permission Date cannot be empty.',
    't_reports_gav_not_found_msg': 'FR GAV must be stated for the entirety of {reportingPeriod}.',
    't_reports_fossilfuelexposure_not_found_msg': 'FR Fossil Fuel Exposure must be stated for the entirety of {reportingPeriod}.',
    't_reports_wasteproduction_not_found_msg': 'FR Waste Contract status must be stated for the entirety of {reportingPeriod}.',
    't_reports_ped_not_found_msg': 'FR {fields} cannot be empty if planning permission was received after 31/12/2020.',
    't_reports_biodiversity_not_found_msg': 'FR {areas} cannot be empty.',
    't_top_down_pathway_success_message_one' : 'FR {0} NZC Top-Down pathways have been uploaded on your model.',
    't_top_down_pathway_success_message_one_single_pathway' : 'FR {0} NZC Top-Down pathway has been uploaded on your model.',
    't_top_down_pathway_success_message_two' : 'FR Your data will be available to view on your NZC model.',
    't_return_to_net_zero_carbon' : 'FR Return to Net Zero Carbon',
    't_save_document':'FR Save document',
    't_save_documents':'FR Save documents',
    't_edit_document':'FR Edit document',
    't_add_another_document':'FR Add another document',
    't_variance_explanation_title': 'FR Variance explanation',
    't_variance_explanation': 'FR Variance for a utility compared to the previous period, or to the target if one is set',
    't_add_new_document':'FR New document',
    't_update_document':'FR Update document',
    't_update_documents':'FR Update documents',
    't_document_updated':'FR Updated',
    't_target_variance': 'FR Target variance',
    't_period_variance': 'FR Period variance',
    't_landlord_data':'FR Landlord Data',
    't_tenant_procurement':'FR Tenant Procurement',
    't_planning_permission_before_year_built':'FR Planning Permission Date must be before the Year built.',
    't_impact_info': 'FR What does this action affect in overall regarding sustainablity',
    't_cost_type_info': 'FR Can the cost associated with actions be something that can be recovered',
    't_scope_info': 'FR Outlining which controlled areas in terms of utilities are affected independent if they are Landlord/Tenant controlled',
    't_gresb_info': 'FR Actions undertaken to reduce consumption and improve efficient use of utilities as a sustainable resource',
    't_payback_period_info': 'FR Time required to recoup the cost of action via the savings generated through its investment',
    't_effect_utilities': 'FR The savings per utility type and its cost. Negative value shows greater savings/reduction and Positive shows an increase',
    't_utility_consumption_year': 'FR Utility consumption per year',
    't_utility_cost_year': 'FR Utility cost per year',
    't_utility_consumption_year_info': 'FR <info_title>Utility consumption after implementing action.</info_title>{0} {1}',
    't_utility_cost_year_info': 'FR <info_title>Costs per year of running the utility after implementing action.</info_title>{0} {1}',
    't_tenant_controlled': 'FR Tenant controlled',
    't_landlord_controlled': 'FR Landlord controlled',
    't_cannot_be_empty':'FR This field cannot be empty',
    't_add_asset_success': 'FR Asset has been created',
    't_add_asset_summary': 'FR Everyone within the fund will have access. To provide non-fund-level users access, go to user permissions.',
    't_edit_asset_title': 'FR Asset has been updated',
    't_edit_asset_summary': 'FR Updates across all modules will be reflected shortly.',
    't_select_framework': 'FR Select a framework',
    't_utility_per_year': 'FR Utility per year',
    't_cost_per_year': 'FR Cost per year',
    't_utility_per_year_info_content_one': 'FR 1000 {0} = 1000 {1} increase over a year',
    't_utility_per_year_info_content_two': 'FR -1000 {0} = 1000 {1} decrease over a year',
    't_cost_per_year_info_content_one': 'FR {0}100/yr = {0}100 increase in cost per year',
    't_cost_per_year_info_content_two': 'FR -{0}100/yr = {0}100 decrease in cost per year',
    't_year_dynamic': 'FR Year {year}',
    't_ped_tooltip_content': 'FR An asset’s Primary Energy Demand (PED) models the amount of energy which must be extracted from primary sources to supply the asset’s typical energy usage, and can often be found on an EPC.',
    't_nzeb_tooltip_content': 'FR The NZEB Threshold is the energy performance target an asset must meet to qualify as a Nearly Zero-Energy Building, calculated according to the appropriate national methodology. Non-EU nations will not have an applicable NZEB threshold.',
    't_sustainable_tonnes_tooltip_content': 'FR Sustainably sourced refers to materials which are recovered, recycled or bio-sourced.',
    't_horizontal_artificial_tooltip_content': 'FR The amount of plan or “bird’s eye” surface area which is non-vegetated.',
    't_total_horizontal_tooltip_content': 'FR The total plan or “bird’s eye” surface area of the asset.',
    't_vertical_artificial_tooltip_content': 'FR The amount of external, vertical surface area which is non-vegetated.',
    't_total_vertical_tooltip_content': 'FR The total external, vertical surface area of the asset.',
    't_click_to_read': 'FR Click here to read more',
    't_reporting_years': 'FR Reporting Years',
    't_data_readiness': 'FR Data Readiness',
    't_waste_contract_status': 'FR Waste Contract Status',
    't_evaluation_date': 'FR Evaluation Date',
    't_add_new_status': 'FR Add new status',
    't_add_historic_status': 'FR Add historic status',
    't_add_new_exposure': 'FR Add new exposure',
    't_add_historic_exposure': 'FR Add historic exposure',
    't_siera_version': 'FR SIERA version',
    't_renewables': 'FR Renewables',
    't_on_site_generation': 'FR On-site generation',
    't_gia_percentage': 'FR {0}% of your GIA {1}',
    't_assets_count': 'FR {0} assets',
    't_self_consumption': 'FR {0}% Self consumption',
    't_export_to_grid': 'FR {0}% Exported to grid',
    't_contribution_electricity_consumption': 'FR {0}% Contribution to electricity consumption',
    't_on_site_generated': 'FR {0}% On site generated',
    't_off_site_purchased': 'FR {0}% Off-site purchased',
    't_non_renewables': 'FR {0}% Non-renewables',
    't_renewables_floor_area': 'FR Renewables floor area',
    't_renewables_floor_area_info': 'FR This percentage is calculated via the number of asset count with on site generation weighted by the floor area',
    't_detailed_renewables_soon': 'FR Detailed performance view for Renewables coming soon.',
    't_record_type_asset_document':'FR Which asset does this document belong to? *',
    't_valid_from_document':'FR Valid from date *',
    't_expiry_date_mandatory':'FR Expiry date *',
    't_end_date_after_start_date': 'FR End date must be after start date',
    't_action_deleted': 'FR Action successfully deleted',
    't_action_deleted_content': 'FR ‘{0}’ action has been deleted by {1}',
    't_select_agent': 'FR Select Agent',
    't_supplier_estimate': 'FR Supplier estimate',
    't_calculated_estimate': 'FR Calculated estimate',
    't_dq_total_asset_floor_area': 'FR Total Asset Floor Area',
    't_floor_area_unaccounted_for': 'FR Floor area unaccounted for',
    't_action_name_exists': 'FR Action name must be unique for the selected asset',
    't_managing_agent_upper_case': 'FR Managing Agent',
    't_data_coverage' : 'FR Data coverage',
    't_data_completeness': 'FR Data completeness',
    't_fund_data_coverage': '<p><b>FR Floor area coverage:</b> Where we have information about meters in a given part of the building for a given utility.</p> <p><b>Floor area unaccounted for: </b> Where we have no information about meters in a given part of a building for a given utility, but we believe this utility is being consumed (this is a measure of floor area). These areas are always assumed to be tenant-procured rather than landlord-procured, except for landlord-controlled assets where no meters have been added.</p>',
    't_fund_data_completeness': '<p><b>FR Actual:</b> Consumption data entered for a meter.</p> <p><b>Supplier estimate:</b> Meter data derived from supplier estimates (e.g. from invoices). These should be treated as actual data for reporting purposes, but they are still less accurate for precise performance monitoring.</p> <p><b>Calculated estimate:</b> Meter data derived from calculated estimates (e.g. calculated by an EVORA consultant using an accepted methodology).</p> <p><b>Missing:</b> Where a meter for a building area has been set up but is missing data for one or more time periods (this is a measure of time).</p>',
    't_add_new_evaluation': 'FR Add new Evaluation',
    't_add_new_occupancy': 'FR Add new Occupancy',
    't_documents_space_exceed':'FR You have exceeded your organisation\'s maximum storage capacity. To upload this document, please {0} to increase your storage limit.',
    't_data_category' : 'FR Data Category',
    't_supplier': 'FR Supplier',
    't_area_served': 'FR Floor Area Served',
    't_add_consumption': 'FR Add consumption',
    't_all_data_categories': 'FR All data categories',
    't_agreed_actions_count_nzc':'FR {0} Agreed actions',
    't_applicable_actions_count_nzc':'FR {0} Applicable actions',
    't_stranding_year_year': 'FR {0} (CRREM Misalignment year)',
    't_not_stranding': 'FR Not CRREM Misaligned',
    't_actions_pathway_recommended': 'FR Actions pathway (recommended)',
    't_actions_pathway_optional': 'FR Actions pathway (optional)',
    't_agreed_actions_pathway': 'FR Agreed actions pathway',
    't_applicable_actions_pathway': 'FR Applicable actions pathway',
    't_bau_pathway': 'FR Business as usual pathway',
    't_fund_view': 'FR Fund view',
    't_assets_list': 'FR Assets list',
    't_chart_specification': 'FR Chart specification',
    't_chart_preconfigured': 'FR This chart has been preconfigured to display:',
    't_grid_decarbonisation_toast': '- FR Grid decarbonisation',
    't_sbt_toast': '- FR Science based target (1.5C)',
    't_bau_toast': '- FR Business as Usual',
    't_agreed_actions_toast': '- FR Agreed Action based pathways',
    't_reporting_year_value': 'FR Reporting year: {0}',
    't_cost_intensity_value': 'FR {0} GBP/m²/yr',
    't_energy_intensity_value': 'FR {0} kWh/m²/yr',
    't_carbon_intensity_value': 'FR {0} kgCO₂e/m²/yr',
    't_co2_emissions_value': 'FR {0} tCO₂e/yr',
    't_data_coverage_percentage_value' : 'FR {0}% Data coverage',
    't_origin_meter_reading': 'FR Meter reading',
    't_origin_invoice': 'FR Invoice',
    't_origin_amr': 'FR AMR',
    't_actual_data': 'FR Actual data',
    'jv_between_funds': 'FR Joint venture between funds:',
    't_meter_inactive_sold': 'FR Meter was inactive or asset was not owned during this month',
    't_coverage': 'FR Coverage',
    't_completeness': 'FR Completeness',
    't_total_asset_floor_gia': 'FR Total asset floor area',
    't_expiry_date_must_be_after_report_date': 'FR Expiry date must be after report date',
    't_unique_file_name': 'FR A file with this name already exists',
    't_special_character': 'FR File name can\'t contain any of the following [ ] # * = / : \\ \' " | , < > & ?',
    't_special_character_comment': 'FR Comment can\'t contain special characters',
    't_custom': 'FR Custom'
  }
}